import React, { useState, useEffect, useMemo } from "react"
import { useNavigate } from "react-router-dom"
import { toast } from "sonner"
import Breadcrumb from "components/Common/Breadcrumb"
import DashboardLoader from "components/Loader/DashboardLoader"
import { jsPDF } from "jspdf"
import html2canvas from "html2canvas"
import emailjs from "@emailjs/browser"
import logoImg from "../../assets/images/QwikBistro.png"
import CreateCustomerModal from "pages/Customers/CreateCustomerModal"

// Create API service for orders
const orderApiService = {
  // Get all orders
  getAllOrders: async () => {
    try {
      const response = await fetch(
        "http://127.0.0.1:8000/order/",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${process.env.REACT_APP_QWIKBISTRO_TOKEN}`,
          },
        },
      )
      const data = await response.json()
      return data.reverse()
    } catch (error) {
      console.error("Error fetching orders:", error)
      throw error
    }
  },

  // Create new order
  createOrder: async orderData => {
    try {
      const response = await fetch(
        "http://127.0.0.1:8000/order/new",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${process.env.REACT_APP_QWIKBISTRO_TOKEN}`,
          },
          body: JSON.stringify(orderData),
        },
      )

      if (!response.ok) {
        throw new Error("Failed to save order")
      }

      return await response.json()
    } catch (error) {
      console.error("Error creating order:", error)
      throw error
    }
  },

  // Get menu items
  getMenuItems: async () => {
    try {
      const response = await fetch(
        "http://127.0.0.1:8000/menuItem/",
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_QWIKBISTRO_TOKEN}`,
          },
        },
      )
      return await response.json()
    } catch (error) {
      console.error("Error fetching menu items:", error)
      throw error
    }
  },

  getAllUsers: async () => {
    try {
      const response = await fetch(
        "http://127.0.0.1:8000/userProfile/",
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_QWIKBISTRO_TOKEN}`,
          },
        },
      )
      return await response.json()
    } catch (error) {
      console.error("Error fetching menu items:", error)
      throw error
    }
  },

  // Search users
  searchUsers: async query => {
    try {
      const response = await fetch(
        `http://127.0.0.1:8000/userProfile/?search=${query}`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_QWIKBISTRO_TOKEN}`,
          },
        },
      )
      return await response.json()
    } catch (error) {
      console.error("Error searching users:", error)
      throw error
    }
  },

  // Create transaction
  createTransaction: async transactionData => {
    try {
      const response = await fetch(
        "http://127.0.0.1:8000/transaction/new",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${process.env.REACT_APP_QWIKBISTRO_TOKEN}`,
          },
          body: JSON.stringify(transactionData),
        },
      )
      return await response.json()
    } catch (error) {
      console.error("Error creating transaction:", error)
      throw error
    }
  },

  // Get promo offers
  getPromoOffers: async () => {
    try {
      const response = await fetch(
        "http://127.0.0.1:8000/promoOffers/",
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_QWIKBISTRO_TOKEN}`,
          },
        },
      )
      return await response.json()
    } catch (error) {
      console.error("Error fetching promo offers:", error)
      throw error
    }
  },
}

const CreateQwikBistroOrderPage = () => {
  const navigate = useNavigate()
  const [isUserSelected, setIsUserSelected] = useState(false)
  const [showCreateCustomerModal, setShowCreateCustomerModal] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [menuItems, setMenuItems] = useState([])
  const [users, setUsers] = useState([])
  const [userLoading, setUserLoading] = useState(false)
  const [selectedUser, setSelectedUser] = useState(null)
  const [searchTerm, setSearchTerm] = useState("")
  const [items, setItems] = useState([])
  const [lastBalance, setLastBalance] = useState(0)

  console.log("last balance", lastBalance)

  const [showComboModal, setShowComboModal] = useState(false)
  const [currentComboItem, setCurrentComboItem] = useState(null)
  const [currentItemId, setCurrentItemId] = useState(null)
  const [isSending, setIsSending] = useState(false)

  // New states for features
  const [promoOffers, setPromoOffers] = useState([])
  const [selectedPromoCode, setSelectedPromoCode] = useState("")
  const [promoLoading, setPromoLoading] = useState(false)
  const [hstPercentage, setHstPercentage] = useState("0")
  const [deliveryMode, setDeliveryMode] = useState("delivery")

  // New states for pickup and delivery details
  const [pickupDate, setPickupDate] = useState(
    new Date().toISOString().split("T")[0],
  )
  const [pickupTime, setPickupTime] = useState("")
  const [deliveryDate, setDeliveryDate] = useState(
    new Date().toISOString().split("T")[0],
  )
  const [deliveryTime, setDeliveryTime] = useState("")
  const [deliveryAddress, setDeliveryAddress] = useState("")
  const [pickupAddress, setPickupAddress] = useState(
    "146 St John St, Saint John, NB E2M 2B5",
  )

  // Initialize order data
  const [orderData, setOrderData] = useState({
    invoiceTo: "",
    companyinvoiceTo: "",
    invoiceNumber: "",
    email: "",
    phone: "",
    paidamount: "",
    tips: "",
    receivedby: "",
    paymentdate: "",
    invoiceDate: new Date().toISOString().split("T")[0],
    transfer: "m7thun@gmail.com",
    discount: "0",
    deliveryFee: "3",
    user_id: "",
    qb_user_id: "",
    // New fields
    promo_code: "",
    hst_percentage: "0",
    delivery_mode: "delivery",
    // Pickup fields
    pickup_date: new Date().toISOString().split("T")[0],
    pickup_time: "",
    // Delivery fields
    delivery_date: new Date().toISOString().split("T")[0],
    delivery_time: "",
    address: "",
  })

  const [totals, setTotals] = useState({
    subtotal: 0,
    discountAmount: 0,
    delivery: 0,
    hstAmount: 0,
    total: 0,
  })

  const [modal, setModal] = useState({
    show: false,
    title: "",
    message: "",
  })

  const [allUsers, setAllUsers] = useState([])

  // Fetch initial data
  const fetchInitialData = async () => {
    try {
      const usersData = await orderApiService.getAllUsers()
      setAllUsers(usersData)

      // Fetch orders to get next ID
      const orders = await orderApiService.getAllOrders()
      const formatCustomerId = id => {
        return `QB-25-${String(id).padStart(4, "0")}`
      }
      const nextId = formatCustomerId(orders.length + 1)

      setOrderData(prev => ({
        ...prev,
        invoiceNumber: nextId,
      }))

      // Fetch menu items
      const menuData = await orderApiService.getMenuItems()
      setMenuItems(menuData)

      // Fetch promo offers
      const promoData = await orderApiService.getPromoOffers()
      setPromoOffers(promoData)

      // Fetch last transaction balance
      await fetchLastBalance()
    } catch (error) {
      toast.error("Failed to load initial data")
      console.error("Error loading data:", error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchInitialData()
  }, [])

  // const fetchLastBalance = async () => {
  //   try {
  //     const response = await fetch("http://127.0.0.1:8000/transaction/", {
  //       headers: {
  //         Authorization: `Bearer ${process.env.REACT_APP_QWIKBISTRO_TOKEN}`,
  //       },
  //     });

  //     if (!response.ok) throw new Error("Failed to fetch transactions");

  //     const data = await response.json();
  //     let lastBalance = 0;

  //     if (data && data.length > 0) {
  //       const sortedTransactions = [...data].sort(
  //         (a, b) =>
  //           new Date(b.systemdate || b.date) - new Date(a.systemdate || a.date)
  //       );

  //       const lastTransactionWithBalance = sortedTransactions.find(
  //         (t) =>
  //           t.balance !== null && t.balance !== undefined && t.balance !== ""
  //       );

  //       if (lastTransactionWithBalance) {
  //         lastBalance = parseFloat(lastTransactionWithBalance.balance) || 0;
  //       }
  //     }

  //     setLastBalance(lastBalance);
  //   } catch (err) {
  //     console.error("Error fetching balance:", err);
  //     setLastBalance(0);
  //   }
  // };

  // Search users

  useEffect(() => {
    if (selectedUser?.qb_user_id) {
      fetchLastBalance(selectedUser.qb_user_id)
    }
  }, [selectedUser])

  useEffect(() => {
    if (selectedUser?.qb_user_id) {
      fetchLastBalance(selectedUser.qb_user_id)
    }
  }, [selectedUser])

  const fetchLastBalance = async qbUserId => {
    try {
      const response = await fetch(
        "http://127.0.0.1:8000/transaction/",
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_QWIKBISTRO_TOKEN}`,
          },
        },
      )

      if (!response.ok) throw new Error("Failed to fetch transactions")

      const data = await response.json()
      let lastBalance = 0

      if (data && data.length > 0) {
        // filter transactions of specific user
        const userTransactions = data.filter(t => t.qb_user_id === qbUserId)

        if (userTransactions.length > 0) {
          const sortedTransactions = [...userTransactions].sort(
            (a, b) =>
              new Date(b.systemdate || b.date) -
              new Date(a.systemdate || a.date),
          )

          const lastTransactionWithBalance = sortedTransactions.find(
            t =>
              t.balance !== null && t.balance !== undefined && t.balance !== "",
          )

          if (lastTransactionWithBalance) {
            lastBalance = parseFloat(lastTransactionWithBalance.balance) || 0
          }
        }
      }

      setLastBalance(lastBalance)
    } catch (err) {
      console.error("Error fetching balance:", err)
      setLastBalance(0)
    }
  }

  useEffect(() => {
    if (searchTerm.length < 2) {
      setUsers([])
      return
    }

    setUserLoading(true)

    const debounceTimer = setTimeout(() => {
      const filteredUsers = allUsers.filter(
        user =>
          user.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          user.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          user.phone?.includes(searchTerm) ||
          user.qb_user_id?.toString().includes(searchTerm),
      )

      setUsers(filteredUsers)
      setUserLoading(false)
    }, 300)

    return () => clearTimeout(debounceTimer)
  }, [searchTerm, allUsers])

  // Calculate totals
  useEffect(() => {
    calculateTotal()
  }, [
    items,
    orderData.discount,
    orderData.deliveryFee,
    hstPercentage,
    selectedPromoCode,
    deliveryMode,
  ])

  // Handlers
  const handleInputChange = (field, value) => {
    setOrderData(prev => ({ ...prev, [field]: value }))
  }

  const handleHstChange = value => {
    const hstValue = parseFloat(value) || 0
    setHstPercentage(value)
    setOrderData(prev => ({ ...prev, hst_percentage: value }))
  }

  const handleDeliveryModeChange = mode => {
    setDeliveryMode(mode)
    setOrderData(prev => ({
      ...prev,
      delivery_mode: mode,
      address: mode === "pickup" ? "" : prev.address, // Clear address if switching to pickup
    }))

    // Update delivery fee based on mode
    if (mode === "pickup") {
      setOrderData(prev => ({ ...prev, deliveryFee: "0" }))
    } else if (mode === "delivery") {
      setOrderData(prev => ({ ...prev, deliveryFee: "3" }))
    }
  }

  const handlePickupDateChange = value => {
    setPickupDate(value)
    setOrderData(prev => ({ ...prev, pickup_date: value }))
  }

  const handlePickupTimeChange = value => {
    setPickupTime(value)
    setOrderData(prev => ({ ...prev, pickup_time: value }))
  }

  const handleDeliveryDateChange = value => {
    setDeliveryDate(value)
    setOrderData(prev => ({ ...prev, delivery_date: value }))
  }

  const handleDeliveryTimeChange = value => {
    setDeliveryTime(value)
    setOrderData(prev => ({ ...prev, delivery_time: value }))
  }

  const handleDeliveryAddressChange = value => {
    setDeliveryAddress(value)
    setOrderData(prev => ({ ...prev, address: value }))
  }

  const handlePickupAddressChange = value => {
    setPickupAddress(value)
    setOrderData(prev => ({ ...prev, address: value }))
  }

  const handlePromoCodeSelect = async promoCode => {
    clearPromoCode()

    setSelectedPromoCode(promoCode)
    setOrderData(prev => ({ ...prev, promo_code: promoCode }))

    // Find the selected promo
    const selectedPromo = promoOffers.find(
      promo => promo.promocode === promoCode,
    )

    if (selectedPromo) {
      if (selectedPromo.is_freedelivery) {
        // Free delivery promo
        setOrderData(prev => ({ ...prev, deliveryFee: "0" }))
        toast.success(`Applied ${selectedPromo.pro_name} - Free Delivery`)
      } else if (selectedPromo.is_percentage) {
        // Percentage discount
        setOrderData(prev => ({
          ...prev,
          discount: selectedPromo.promo_percentage,
        }))
        toast.success(
          `Applied ${selectedPromo.pro_name} - ${selectedPromo.promo_percentage}% off`,
        )
      } else if (selectedPromo.is_fixedamount) {
        // Fixed amount discount - This will be handled in calculateTotal
        toast.success(
          `Applied ${selectedPromo.pro_name} - $${selectedPromo.promo_fixedamount} off`,
        )
      }
    }
  }

  const clearPromoCode = () => {
    setSelectedPromoCode("")
    setOrderData(prev => ({
      ...prev,
      promo_code: "",
      discount: "0",
      deliveryFee: deliveryMode === "delivery" ? "3" : "0",
    }))
    // toast.info("Promo code cleared");
  }

  const addItem = () => {
    setItems(prev => [
      ...prev,
      {
        id: Date.now(),
        itemName: "",
        quantity: 1,
        price: 0,
        total: 0,
        manualTotal: null,
      },
    ])
  }

  const removeItem = id => {
    setItems(prev => prev.filter(item => item.id !== id))
  }

  const updateItem = (id, field, value) => {
    setItems(prev =>
      prev.map(item => {
        if (item.id === id) {
          const updatedItem = { ...item, [field]: value }

          if (field === "itemName") {
            const matchedItem = menuItems.find(
              menuItem => menuItem.item_name === value,
            )

            if (matchedItem) {
              if (matchedItem.is_combo) {
                setTimeout(() => {
                  setShowComboModal(true)
                  setCurrentComboItem(matchedItem)
                  setCurrentItemId(id)
                }, 0)
                return item
              }

              updatedItem.price = parseFloat(matchedItem.price) || 0
              updatedItem.manualTotal = null
            } else {
              updatedItem.price = 0
              updatedItem.manualTotal = null
            }
          }

          if (field === "total") {
            updatedItem.manualTotal = parseFloat(value) || 0
            return updatedItem
          }

          if (field === "quantity" || field === "price") {
            const quantity = parseInt(updatedItem.quantity) || 0
            const price = parseFloat(updatedItem.price) || 0
            updatedItem.total = quantity * price
            updatedItem.manualTotal = null
          }

          return updatedItem
        }
        return item
      }),
    )
  }

  const calculateTotal = () => {
    // Calculate subtotal
    const subtotal = items.reduce(
      (sum, item) =>
        sum +
        (item.manualTotal !== null
          ? item.manualTotal
          : (item.quantity || 0) * (item.price || 0)),
      0,
    )

    // Calculate discount based on promo or manual discount
    const discount = parseFloat(orderData.discount) || 0
    let discountAmount = 0

    // Check if a fixed amount promo is selected
    const selectedPromo = promoOffers.find(
      promo => promo.promocode === selectedPromoCode,
    )
    if (selectedPromo?.is_fixedamount) {
      discountAmount = parseFloat(selectedPromo.promo_fixedamount) || 0
    } else {
      discountAmount = (discount / 100) * subtotal
    }

    // Calculate delivery fee
    let deliveryFee = 0
    if (deliveryMode === "delivery") {
      // Check if free delivery promo is applied
      const hasFreeDeliveryPromo = selectedPromo?.is_freedelivery
      if (!hasFreeDeliveryPromo) {
        deliveryFee = parseFloat(orderData.deliveryFee) || 0
      }
    }

    // Calculate HST
    const hstPercent = parseFloat(hstPercentage) || 0
    const hstAmount = (hstPercent / 100) * (subtotal - discountAmount)

    // Calculate total
    const total = subtotal - discountAmount + deliveryFee + hstAmount

    setTotals({
      subtotal,
      discountAmount,
      delivery: deliveryFee,
      hstAmount,
      total,
    })
  }

  // Handler for when customer is created successfully
  const handleCustomerCreated = customer => {
    console.log("New customer created:", customer)
    fetchInitialData()
    handleUserSelect(customer)
  }

  const handleUserSelect = user => {
    setSelectedUser(user)
    setIsUserSelected(true)

    if (user) {
      setOrderData(prev => ({
        ...prev,
        invoiceTo: user.name || "",
        companyinvoiceTo: user.address || "",
        email: user.email || "",
        phone: user.phone || "",
        user_id: user.id || "",
        qb_user_id: user.qb_user_id || "",
        // Set delivery address from user data
        address: user.address || "",
      }))
      setDeliveryAddress(user.address || "")
      setSearchTerm(user ? `${user.name} (${user.qb_user_id})` : "")
      setUsers([])
    } else {
      setOrderData(prev => ({
        ...prev,
        invoiceTo: "",
        companyinvoiceTo: "",
        email: "",
        phone: "",
        address: "",
      }))
      setDeliveryAddress("")
      setSearchTerm("")
      setIsUserSelected(false)
    }
  }

  // Format time to 12-hour format
  const formatTo12Hour = time24 => {
    if (!time24) return ""

    const [hours, minutes] = time24.split(":").map(Number)
    const ampm = hours >= 12 ? "PM" : "AM"
    const hours12 = hours % 12 || 12 // Convert 0 to 12 for 12 AM

    return `${hours12}:${minutes.toString().padStart(2, "0")} ${ampm}`
  }

  const saveOrder = async () => {
    // Validate required fields based on delivery mode
    if (deliveryMode === "pickup") {
      if (!pickupDate) {
        toast.error("Pickup date is required")
        return
      }
      if (!pickupTime) {
        toast.error("Pickup time is required")
        return
      }
      if (!pickupAddress) {
        toast.error("Pickup time is required")
        return
      }
    } else if (deliveryMode === "delivery") {
      if (!deliveryDate) {
        toast.error("Delivery date is required")
        return
      }
      if (!deliveryTime) {
        toast.error("Delivery time is required")
        return
      }
      if (!deliveryAddress.trim()) {
        toast.error("Delivery address is required")
        return
      }
    }

    if (totals.total <= 0) {
      setModal({
        show: true,
        title: "Validation Error",
        message: "Please add items and calculate total first.",
      })
      return
    }

    // const confirmSave = window.confirm("Do you want to save this order to the database?");
    // if (!confirmSave) return;

    setIsSubmitting(true)
    try {
      // Map items
      const orderProducts = items.map(item => {
        const menuItem = menuItems.find(
          menuItem => menuItem.item_name === item.itemName,
        )

        const totalPrice =
          item.manualTotal !== null
            ? item.manualTotal
            : (item.quantity || 0) * (item.price || 0)

        return menuItem
          ? {
              id: menuItem.id,
              name: item.itemName,
              price: item.price,
              totalPrice: totalPrice,
              quantity: item.quantity,
              image: menuItem.image1,
              vat: item.vat || "0",
              discount: item.discount || "0",
            }
          : {
              id: Date.now(),
              name: item.itemName,
              price: item.price || 0,
              totalPrice: totalPrice,
              quantity: item.quantity,
              image: "",
              vat: item.vat || "0",
              discount: item.discount || "0",
            }
      })

      const orderPayload = {
        user_id: orderData.user_id || "",
        qb_user_id: orderData.qb_user_id || "",
        order_date: orderData.invoiceDate,
        user_email: orderData.email,
        total_amount: totals.total.toFixed(2),
        status: "pending",
        payment_method: "e-Transfer",
        payment_status: "not paid",
        username: orderData.invoiceTo,
        address: deliveryMode === "delivery" ? deliveryAddress : pickupAddress,
        totalprice: totals.total.toFixed(2),
        deliverycharge: orderData.deliveryFee,
        interac_e_transfer: orderData.transfer,
        orderproductdata: orderProducts,
        phonenumber: orderData.phone,
        paidamount: orderData.paidamount || "",
        tips: orderData.tips || "",
        receivedby: orderData.receivedby || "",
        paymentdate: orderData.paymentdate || "",
        qb_order_id: orderData.invoiceNumber || "",
        // New fields
        promo_code: orderData.promo_code,
        hst_percentage: orderData.hst_percentage,
        delivery_mode: orderData.delivery_mode,
        hst_amount: totals.hstAmount.toFixed(2),
        // Pickup fields
        pickup_date: deliveryMode === "pickup" ? pickupDate : "",
        pickup_time: deliveryMode === "pickup" ? pickupTime : "",
        // Delivery fields
        delivery_date: deliveryMode === "delivery" ? deliveryDate : "",
        delivery_time: deliveryMode === "delivery" ? deliveryTime : "",
      }

      // Save order
      const savedOrder = await orderApiService.createOrder(orderPayload)

      // Create transaction
      const totalAmount = parseFloat(savedOrder?.total_amount) || 0
      const transactionData = {
        qb_user_id: savedOrder?.qb_user_id || "",
        system_user_id: savedOrder?.user_id || "",
        date: new Date().toISOString().split("T")[0],
        qb_order_id: savedOrder?.qb_order_id || "",
        system_order_id: savedOrder?.id || "",
        total: savedOrder?.total_amount || "",
        tips: 0,
        balance: lastBalance + totalAmount,
      }

      await orderApiService.createTransaction(transactionData)

      toast.success("Order created successfully")

      // Navigate after delay
      setTimeout(() => {
        navigate("/all-qwikbistro-orders")
      }, 1500)
    } catch (error) {
      console.error("Error saving order:", error)
      toast.error("Failed to save order")
    } finally {
      setIsSubmitting(false)
    }
  }

  // Generate PDF function (keep as is)
  const generatePDF = async () => {
    if (totals.total <= 0) {
      setModal({
        show: true,
        title: "Validation Error",
        message: "Please add items and calculate total first.",
      })
      return
    }

    const input = document.getElementById("invoice")
    html2canvas(input, {
      scale: 2,
      dpi: 300,
      letterRendering: true,
    }).then(canvas => {
      const imgData = canvas.toDataURL("image/jpeg", 1.0)
      const pdf = new jsPDF("p", "mm", "a4")
      const imgWidth = 210
      const imgHeight = (canvas.height * imgWidth) / canvas.width

      pdf.addImage(imgData, "JPEG", 0, 0, imgWidth, imgHeight)
      pdf.save(`Qwik_Bistro_Invoice_${orderData.invoiceNumber || "order"}.pdf`)
    })
  }

  const handleSendInvoice = async () => {
    console.log("order data", orderData)

    if (!orderData.email.trim()) {
      setModal({
        show: true,
        title: "Validation Error",
        message: "Email address is required.",
      })
      return
    }

    if (totals.total <= 0 || items.length === 0) {
      setModal({
        show: true,
        title: "Validation Error",
        message: "Please add at least one item and calculate total.",
      })
      return
    }

    try {
      setIsSending(true)
      const emailHTML = generateEmailHTML()

      if (emailHTML.length > 100000) {
        throw new Error("Invoice content too large")
      }

      const templateParams = {
        subject_name: "Qwik Bistro Order",
        email: orderData.email || "",
        to_name: orderData.invoiceTo,
        invoice_html: emailHTML,
        invoice_number: orderData.invoiceNumber || "N/A",
        total_amount: totals.total.toFixed(2),
        company_name: "Qwik Bistro",
      }

      await emailjs.send(
        "service_qhz8vu9",
        "template_mhctmyk",
        templateParams,
        "GOJnpBoj2QdmeSr6h",
      )

      toast.success(`Invoice #${orderData.invoiceNumber} sent successfully!`)
    } catch (error) {
      console.error("Error sending invoice:", error)
      toast.error("Failed to send invoice")
    } finally {
      setIsSending(false)
    }
  }

  const generateEmailHTML = () => {
    const formattedDate = new Date(orderData.invoiceDate).toLocaleDateString(
      "en-CA",
      {
        year: "numeric",
        month: "long",
        day: "numeric",
      },
    )

    const itemsRows = items
      .map(
        item => `
      <tr>
        <td style="padding:10px 10px;border-bottom:1px solid #eee;text-align:left;">${item.itemName}</td>
        <td style="padding:10px 10px;border-bottom:1px solid #eee;text-align:center;">${item.price ? `$${item.price.toFixed(2)}` : "-"}</td>
        <td style="padding:10px 10px;border-bottom:1px solid #eee;text-align:center;">${item.quantity == 0 ? "-" : item.quantity}</td>
        <td style="padding:10px 10px;border-bottom:1px solid #eee;text-align:right;">$${
          item?.manualTotal
            ? item?.manualTotal.toFixed(2)
            : (item.quantity * item.price).toFixed(2)
        }</td>
      </tr>
    `,
      )
      .join("")

    // Format dates and times for display
    const displayDate =
      deliveryMode === "pickup"
        ? new Date(pickupDate).toLocaleDateString("en-CA", {
            year: "numeric",
            month: "long",
            day: "numeric",
          })
        : new Date(deliveryDate).toLocaleDateString("en-CA", {
            year: "numeric",
            month: "long",
            day: "numeric",
          })

    const displayTime =
      deliveryMode === "pickup"
        ? formatTo12Hour(pickupTime)
        : formatTo12Hour(deliveryTime)

    // <p style="font-size:13px;margin:5px 0;">${deliveryMode === "pickup" ? "Pickup" : "Delivery"}: ${displayDate}</p>
    //       <p style="font-size:13px;margin:5px 0;">${deliveryMode === "pickup" ? "Pickup Time" : "Delivery Time"}: ${displayTime}</p>

    //  <p style="margin:5px 0;">${deliveryMode === "pickup" ? "Pickup" : "Delivery"}: <span style="font-weight:bold;">${displayDate} at ${displayTime}</span></p>

    const SmsAddress =
      deliveryMode == "delivery" ? deliveryAddress : pickupAddress

    const deliveryMode1 = deliveryMode == "pickup" ? "Pickup" : "Delivery"

    return `
    <div style="width:100%;max-width:800px;margin:0 auto;font-family:Arial,sans-serif;">
      <table width="100%" cellpadding="0" cellspacing="0" border="0">
        <tr>
          <td align="center" style="padding:20px 0;">
            <img src="https://res.cloudinary.com/dlaeldpqy/image/upload/v1748246850/QwikBistro_olrbbh.png" width="116" height="116" style="display:block;margin:0 auto;"/>
          </td>
        </tr>
      </table>

      <!-- Invoice Header -->
      <table width="100%" cellpadding="0" cellspacing="0" style="margin-bottom:20px;">
        <tr>
          <td width="50%" valign="top" style="padding:10px;">
            <p style="font-size:14px;margin:0 0 5px 0;">Invoice to:</p>
            <p style="font-size:16px;font-weight:bold;color:#e76f51;margin:5px 0;">${orderData.invoiceTo}</p>
            <p style="font-size:13px;margin:5px 0;">${SmsAddress}</p>
           
          </td>
          <td width="50%" valign="top" style="padding:10px;text-align:right;">
            <p style="font-size:13px;margin:5px 0;">Invoice # ${orderData.invoiceNumber}</p>
            <p style="font-size:13px;margin:5px 0;">Date: ${formattedDate}</p>
            <p style="font-size:13px;margin:5px 0;"> Delivery mode: ${deliveryMode1}</p>
            
          </td>
        </tr>
      </table>

      <!-- Divider -->
      <table width="100%" cellpadding="0" cellspacing="0" style="border-top:1px dashed #e76f51;margin:20px 0;"></table>

      <!-- Items Table -->
      <table width="100%" cellpadding="0" cellspacing="0" style="margin-bottom:20px;">
        <tr>
          <td width="46%" style="padding:5px 8px;font-weight:bold;text-align:left;">ITEM</td>
          <td width="20%" style="padding:5px 8px;font-weight:bold;text-align:center;">UNIT PRICE</td>
          <td width="16%" style="padding:5px 8px;font-weight:bold;text-align:center;">QNTY</td>
          <td width="18%" style="padding:5px 8px;font-weight:bold;text-align:right;">PRICE</td>
        </tr>
        ${itemsRows}
      </table>

      <!-- Divider -->
      <table width="100%" cellpadding="0" cellspacing="0" style="border-top:1px dashed #e76f51;margin:20px 0;"></table>

      <!-- Totals -->
      <table width="100%" cellpadding="0" cellspacing="0">
        <tr>
          <td width="70%" style="text-align:right;padding:5px 10px;">Subtotal:</td>
          <td width="30%" style="text-align:right;padding:5px 10px;">$${totals.subtotal.toFixed(2)}</td>
        </tr>
        
        ${
          totals.discountAmount > 0
            ? `
          <tr>
            <td style="text-align:right;padding:5px 10px;">Discount:</td>
            <td style="text-align:right;padding:5px 10px;color:#01a859;">- $${totals.discountAmount.toFixed(2)}</td>
          </tr>
        `
            : ""
        }

        ${
          deliveryMode === "delivery" && totals.delivery > 0
            ? `
          <tr>
            <td style="text-align:right;padding:5px 10px;">Delivery Fee:</td>
            <td style="text-align:right;padding:5px 10px;">$${totals.delivery.toFixed(2)}</td>
          </tr>
        `
            : ""
        }
        
        ${
          totals.hstAmount > 0
            ? `
          <tr>
            <td style="text-align:right;padding:5px 10px;">Text (HST ${hstPercentage}%):</td>
            <td style="text-align:right;padding:5px 10px;">$${totals.hstAmount.toFixed(2)}</td>
          </tr>
        `
            : ""
        }
        
        <tr>
          <td style="text-align:right;padding:5px 10px;font-weight:bold;">Total:</td>
          <td style="text-align:right;padding:5px 10px;font-weight:bold;">$${totals.total.toFixed(2)}</td>
        </tr>
      </table>

      <!-- Payment Method -->
      <table width="100%" cellpadding="0" cellspacing="0" style="margin-top:20px;">
        <tr>
          <td style="padding:10px 0;">
            <p style="font-weight:bold;margin:5px 0;">Payment Method:</p>
            <p style="margin:5px 0;">Interac e-Transfer: <span style="font-weight:bold;">${orderData.transfer}</span></p>
           
          </td>
        </tr>
      </table>

      <!-- Footer -->
      <table width="100%" cellpadding="0" cellspacing="0" style="margin-top:15px;">
        <tr>
          <td>
            <!-- First line: Phone (left) and Website (right) -->
            <table width="100%" cellpadding="0" cellspacing="0">
              <tr>
                <td width="50%" style="text-align:left;">
                  <p style="color:#e76f51;font-weight:700;margin:5px 0;">(506) 899-3939</p>
                </td>
                <td width="50%" style="text-align:right;">
                  <p style="color:#e76f51;font-weight:700;margin:5px 0;">qwikbistro.ca</p>
                </td>
              </tr>
            </table>
            
            <!-- Second line: Reg # (left) and Certificate (right) -->
            <table width="100%" cellpadding="0" cellspacing="0">
              <tr>
                <td width="50%" style="text-align:left;">
                  <p style="font-size:11px;margin:5px 0;">NB Reg # 726813942NP0001</p>
                </td>
                <td width="50%" style="text-align:right;">
                  <p style="font-size:11px;margin:5px 0;">Managing Food Safety Certificate # 32234402</p>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </div>
  `
  }

  // Modal component
  const Modal = ({ isOpen, onClose, title, children }) => {
    if (!isOpen) return null

    return (
      <div
        className="modal fade show d-block"
        style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{title}</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">{children}</div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={onClose}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  // Combo modal handlers
  const handleComboSubmit = description => {
    setItems(prev =>
      prev.map(item => {
        if (item.id === currentItemId) {
          return {
            ...item,
            itemName: description,
            price: parseFloat(currentComboItem.price) || 0,
            total:
              (item.quantity || 1) * (parseFloat(currentComboItem.price) || 0),
          }
        }
        return item
      }),
    )
    setShowComboModal(false)
    setCurrentComboItem(null)
    setCurrentItemId(null)
  }

  const handleComboCancel = () => {
    setShowComboModal(false)
    setCurrentComboItem(null)
    setCurrentItemId(null)
  }

  if (isLoading) {
    return <DashboardLoader />
  }

  return (
    <div
      className="page-content"
      style={{
        fontFamily: "'Quicksand', sans-serif",
      }}
    >
      <div className="container-fluid">
        <Breadcrumb title="Orders" breadcrumbItem="Create New Order" />

        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                {/* <div className="d-flex justify-content-between align-items-center mb-3">
                  <h4 className="card-title mb-4">Create New Order</h4>
                  <button
                    onClick={() => setShowCreateCustomerModal(true)}
                    className="btn btn-success"
                  >
                    <i className="fas fa-plus me-1"></i> Create New Customer
                  </button>
                </div> */}

                {/* Order Information */}
                <div className="row mb-4">
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">Customer</label>

                      <div className="d-flex gap-2">
                        <div
                          className="position-relative"
                          style={{ width: "90%" }}
                        >
                          <input
                            type="text"
                            className="form-control"
                            value={searchTerm}
                            onChange={e => setSearchTerm(e.target.value)}
                            placeholder="Search by name or user ID..."
                          />
                          {users.length > 0 &&
                          searchTerm.length >= 2 &&
                          !userLoading ? (
                            <div
                              className="position-absolute w-100 bg-white border rounded shadow-lg mt-1 z-1"
                              style={{ maxHeight: "200px", overflowY: "auto" }}
                            >
                              {users.map(user => (
                                <div
                                  key={user.id}
                                  className="p-2 border-bottom hover-bg-light cursor-pointer"
                                  onClick={() => handleUserSelect(user)}
                                >
                                  <div className="d-flex justify-content-between">
                                    <span>{user.name}</span>
                                    <small className="text-muted">
                                      {user.qb_user_id}
                                    </small>
                                  </div>
                                </div>
                              ))}
                            </div>
                          ) : searchTerm.length >= 2 && userLoading ? (
                            <div className="position-absolute w-100 bg-white border rounded shadow-lg mt-1 z-1 p-2">
                              <div className="text-center text-muted">
                                <i className="fas fa-spinner fa-spin me-2"></i>
                                Searching...
                              </div>
                            </div>
                          ) : null}
                        </div>

                        <button
                          onClick={() => setShowCreateCustomerModal(true)}
                          className="btn btn-secondary"
                          style={{ width: "38px" }}
                        >
                          <i className="fas fa-plus me-1"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">Order ID *</label>
                      <input
                        type="text"
                        className="form-control"
                        value={orderData.invoiceNumber}
                        onChange={e =>
                          handleInputChange("invoiceNumber", e.target.value)
                        }
                        required
                      />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">Order Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={orderData.invoiceDate}
                        onChange={e =>
                          handleInputChange("invoiceDate", e.target.value)
                        }
                      />
                    </div>
                  </div>
                </div>

                {/* Customer Details */}
                <div className="row mb-4">
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">Name *</label>
                      <input
                        type="text"
                        className="form-control"
                        value={orderData.invoiceTo}
                        onChange={e =>
                          handleInputChange("invoiceTo", e.target.value)
                        }
                        required
                      />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">Phone *</label>
                      <input
                        type="text"
                        className="form-control"
                        value={orderData.phone}
                        onChange={e =>
                          handleInputChange("phone", e.target.value)
                        }
                        required
                      />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">Email *</label>
                      <input
                        type="email"
                        className="form-control"
                        value={orderData.email}
                        onChange={e =>
                          handleInputChange("email", e.target.value)
                        }
                        required
                      />
                    </div>
                  </div>
                </div>

                {/* <div className="row mb-4">
                  
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">Customer Address *</label>
                      <input
                        type="text"
                        className="form-control"
                        value={orderData.companyinvoiceTo}
                        onChange={(e) => handleInputChange('companyinvoiceTo', e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  

                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">Interac E-Transfer</label>
                      <input
                        type="text"
                        className="form-control"
                        value={orderData.transfer}
                        onChange={(e) => handleInputChange('transfer', e.target.value)}
                      />
                    </div>
                  </div>
                </div> */}

                {/* Delivery Mode */}
                <div className="row mb-4">
                  <div className="col-md-12 d-flex gap-5 align-items-center">
                    <label className="form-label">Delivery Mode *</label>
                    <div className="d-flex gap-4">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="deliveryMode"
                          id="delivery"
                          value="delivery"
                          checked={deliveryMode === "delivery"}
                          onChange={e =>
                            handleDeliveryModeChange(e.target.value)
                          }
                        />
                        <label className="form-check-label" htmlFor="delivery">
                          Delivery
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="deliveryMode"
                          id="pickup"
                          value="pickup"
                          checked={deliveryMode === "pickup"}
                          onChange={e =>
                            handleDeliveryModeChange(e.target.value)
                          }
                        />
                        <label className="form-check-label" htmlFor="pickup">
                          Pickup
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Pickup Fields - Only show when pickup is selected */}
                {deliveryMode === "pickup" && (
                  <div className="row mb-4">
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label">Pickup Date *</label>
                        <input
                          type="date"
                          className="form-control"
                          value={pickupDate}
                          onChange={e => handlePickupDateChange(e.target.value)}
                          min={new Date().toISOString().split("T")[0]}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label">Pickup Time *</label>
                        <select
                          className="form-control"
                          value={pickupTime}
                          onChange={e => handlePickupTimeChange(e.target.value)}
                          required
                        >
                          <option value="">Select Pickup Time</option>
                          <option value="14:00">02:00 PM</option>
                          <option value="14:30">02:30 PM</option>
                          <option value="15:00">03:00 PM</option>
                          <option value="15:30">03:30 PM</option>
                          <option value="16:00">04:00 PM</option>
                          <option value="16:30">04:30 PM</option>
                          <option value="17:00">05:00 PM</option>
                          <option value="17:30">05:30 PM</option>
                          <option value="18:00">06:00 PM</option>
                          <option value="18:30">06:30 PM</option>
                          <option value="19:00">07:00 PM</option>
                          <option value="19:30">07:30 PM</option>
                          <option value="20:00">08:00 PM</option>
                          <option value="20:30">08:30 PM</option>
                          <option value="21:00">09:00 PM</option>
                          <option value="21:30">09:30 PM</option>
                          <option value="22:00">10:00 PM</option>
                        </select>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label">Pickup Address *</label>
                        <textarea
                          className="form-control"
                          value={pickupAddress}
                          onChange={e =>
                            handlePickupAddressChange(e.target.value)
                          }
                          rows="1"
                          required
                          placeholder="Enter pickup address"
                        />
                      </div>
                    </div>

                    {/* <div className="col-md-12">
                      <div className="alert alert-info">
                        <p className="mb-1">
                          <strong>Pickup Address:</strong> 146 St John St, Saint John, NB E2M2B5
                        </p>
                        <p className="mb-0">
                          <strong>Pickup Hours:</strong> 02:00 PM - 10:00 PM
                        </p>
                      </div>
                    </div> */}
                  </div>
                )}

                {/* Delivery Fields - Only show when delivery is selected */}
                {deliveryMode === "delivery" && (
                  <div className="row mb-4">
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label">Delivery Date *</label>
                        <input
                          type="date"
                          className="form-control"
                          value={deliveryDate}
                          onChange={e =>
                            handleDeliveryDateChange(e.target.value)
                          }
                          min={new Date().toISOString().split("T")[0]}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label">Delivery Time *</label>
                        <select
                          className="form-control"
                          value={deliveryTime}
                          onChange={e =>
                            handleDeliveryTimeChange(e.target.value)
                          }
                          required
                        >
                          <option value="">Select Delivery Time</option>
                          <option value="16:00">04:00 PM</option>
                          <option value="16:30">04:30 PM</option>
                          <option value="17:00">05:00 PM</option>
                          <option value="17:30">05:30 PM</option>
                          <option value="18:00">06:00 PM</option>
                          <option value="18:30">06:30 PM</option>
                          <option value="19:00">07:00 PM</option>
                          <option value="19:30">07:30 PM</option>
                          <option value="20:00">08:00 PM</option>
                          <option value="20:30">08:30 PM</option>
                          <option value="21:00">09:00 PM</option>
                          <option value="21:30">09:30 PM</option>
                          <option value="22:00">10:00 PM</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label">Delivery Address *</label>
                        <textarea
                          className="form-control"
                          value={deliveryAddress}
                          onChange={e =>
                            handleDeliveryAddressChange(e.target.value)
                          }
                          rows="1"
                          required
                          placeholder="Enter delivery address"
                        />
                      </div>
                    </div>
                    {/* <div className="col-md-12">
                      <div className="alert alert-info">
                        <p className="mb-1">
                          <strong>Delivery Hours:</strong> 04:00 PM - 10:00 PM
                        </p>
                        <p className="mb-0">
                          <strong>Note:</strong> Free delivery on orders over $30
                        </p>
                      </div>
                    </div> */}
                  </div>
                )}

                {/* Payment Details */}
                {/* <div className="row mb-4">
                  <div className="col-md-3">
                    <div className="mb-3">
                      <label className="form-label">Paid Amount</label>
                      <input
                        type="number"
                        className="form-control"
                        value={orderData.paidamount}
                        onChange={(e) => handleInputChange('paidamount', e.target.value)}
                        step="0.01"
                      />
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="mb-3">
                      <label className="form-label">Tips</label>
                      <input
                        type="number"
                        className="form-control"
                        value={orderData.tips}
                        onChange={(e) => handleInputChange('tips', e.target.value)}
                        step="0.01"
                      />
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="mb-3">
                      <label className="form-label">Received By</label>
                      <input
                        type="text"
                        className="form-control"
                        value={orderData.receivedby}
                        onChange={(e) => handleInputChange('receivedby', e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="mb-3">
                      <label className="form-label">Payment Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={orderData.paymentdate}
                        onChange={(e) => handleInputChange('paymentdate', e.target.value)}
                      />
                    </div>
                  </div>
                </div> */}

                {/* Order Items Section */}
                <div className="mb-4">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="mb-0">Order Items</h5>
                    <button
                      type="button"
                      className="btn btn-primary btn-sm"
                      onClick={addItem}
                    >
                      <i className="fas fa-plus me-1"></i> Add Item
                    </button>
                  </div>

                  {items.length > 0 ? (
                    <div className="table-responsive">
                      <table className="table table-bordered table-hover">
                        <thead className="table-light">
                          <tr>
                            <th width="40%">Item</th>
                            <th width="15%">Quantity</th>
                            <th width="15%">Unit Price</th>
                            <th width="15%">Item Total</th>
                            <th width="15%">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {items.map(item => (
                            <tr key={item.id}>
                              <td>
                                <input
                                  list={`itemList-${item.id}`}
                                  className="form-control form-control-sm"
                                  value={item.itemName}
                                  onChange={e => {
                                    setItems(prev =>
                                      prev.map(i =>
                                        i.id === item.id
                                          ? { ...i, itemName: e.target.value }
                                          : i,
                                      ),
                                    )
                                  }}
                                  onBlur={e => {
                                    updateItem(
                                      item.id,
                                      "itemName",
                                      e.target.value,
                                    )
                                  }}
                                  placeholder="Type or select item"
                                />
                                <datalist id={`itemList-${item.id}`}>
                                  {menuItems.map(menuItem => (
                                    <option
                                      key={menuItem.id}
                                      value={menuItem.item_name}
                                    />
                                  ))}
                                </datalist>
                              </td>
                              <td>
                                <input
                                  type="number"
                                  className="form-control form-control-sm"
                                  value={item.quantity}
                                  min="0"
                                  step="1"
                                  onChange={e => {
                                    const value = parseFloat(e.target.value)
                                    updateItem(
                                      item.id,
                                      "quantity",
                                      isNaN(value) ? 0 : value,
                                    )
                                  }}
                                />
                              </td>
                              <td>
                                <input
                                  type="number"
                                  className="form-control form-control-sm"
                                  value={item.price}
                                  min="0"
                                  step="0.01"
                                  onChange={e =>
                                    updateItem(
                                      item.id,
                                      "price",
                                      parseFloat(e.target.value) || 0,
                                    )
                                  }
                                />
                              </td>
                              <td>
                                <input
                                  type="number"
                                  className="form-control form-control-sm"
                                  value={
                                    item.manualTotal !== null
                                      ? item.manualTotal
                                      : (item.quantity * item.price).toFixed(2)
                                  }
                                  onChange={e =>
                                    updateItem(item.id, "total", e.target.value)
                                  }
                                  onFocus={e => e.target.select()}
                                  step="0.01"
                                  min="0"
                                />
                              </td>
                              <td className="text-center">
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm"
                                  onClick={() => removeItem(item.id)}
                                >
                                  <i className="fas fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div className="alert alert-info text-center">
                      No items added. Click "Add Item" to add order items.
                    </div>
                  )}
                </div>

                {/* Pricing & Calculation */}
                <div className="row mb-4">
                  <div className="col-md-6">
                    <div className="card">
                      <div className="card-body">
                        <h5 className="card-title mb-3">
                          Pricing & Promotions
                        </h5>

                        <div className="row mb-3">
                          <div className="col-md-6">
                            <label className="form-label">Discount (%)</label>
                            <input
                              type="number"
                              className="form-control"
                              value={orderData.discount}
                              onChange={e =>
                                handleInputChange("discount", e.target.value)
                              }
                              step="0.01"
                              min="0"
                            />
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">Delivery Fee</label>
                            <input
                              type="number"
                              className="form-control"
                              value={orderData.deliveryFee}
                              onChange={e =>
                                handleInputChange("deliveryFee", e.target.value)
                              }
                              step="0.01"
                              min="0"
                              // disabled={deliveryMode === "pickup"}
                            />
                          </div>
                        </div>

                        <div className="row mb-3">
                          <div className="col-md-6">
                            <label className="form-label">Promo Code</label>
                            <div className="input-group">
                              <select
                                className="form-control"
                                value={selectedPromoCode}
                                onChange={e =>
                                  handlePromoCodeSelect(e.target.value)
                                }
                              >
                                <option value="">Select Promo Code</option>
                                {promoOffers.map(promo => (
                                  <option
                                    key={promo.id}
                                    value={promo.promocode}
                                  >
                                    {promo.pro_name} ({promo.promocode})
                                  </option>
                                ))}
                              </select>
                              {selectedPromoCode && (
                                <button
                                  className="btn btn-outline-danger"
                                  type="button"
                                  onClick={clearPromoCode}
                                >
                                  <i className="fas fa-times"></i>
                                </button>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">Tax (HST %)</label>
                            <input
                              type="number"
                              className="form-control"
                              value={hstPercentage}
                              onChange={e => handleHstChange(e.target.value)}
                              step="0.01"
                              min="0"
                              max="100"
                            />
                          </div>
                        </div>

                        <div className="mt-3">
                          <button
                            type="button"
                            className="btn btn-info w-100"
                            onClick={calculateTotal}
                          >
                            <i className="fas fa-calculator me-1"></i> Calculate
                            Total
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="card">
                      <div className="card-body">
                        <h5 className="card-title mb-3">Order Summary</h5>

                        <div className="mb-2 d-flex justify-content-between">
                          <span>Subtotal:</span>
                          <span className="fw-semibold">
                            ${totals.subtotal.toFixed(2)}
                          </span>
                        </div>

                        {totals.discountAmount > 0 && (
                          <div className="mb-2 d-flex justify-content-between text-success">
                            <span>Discount:</span>
                            <span className="fw-semibold">
                              -${totals.discountAmount.toFixed(2)}
                            </span>
                          </div>
                        )}

                        {deliveryMode === "delivery" && totals.delivery > 0 && (
                          <div className="mb-2 d-flex justify-content-between">
                            <span>Delivery Fee:</span>
                            <span className="fw-semibold">
                              ${totals.delivery.toFixed(2)}
                            </span>
                          </div>
                        )}

                        {totals.hstAmount > 0 && (
                          <div className="mb-2 d-flex justify-content-between">
                            <span>Tax (HST {hstPercentage}%):</span>
                            <span className="fw-semibold">
                              ${totals.hstAmount.toFixed(2)}
                            </span>
                          </div>
                        )}

                        <hr />

                        <div className="d-flex justify-content-between">
                          <span className="fw-bold">Total:</span>
                          <span className="fw-bold fs-5">
                            ${totals.total.toFixed(2)}
                          </span>
                        </div>

                        {/* <div className="mt-3 text-muted small">
                          <div>Delivery Mode: <strong>{deliveryMode.toUpperCase()}</strong></div>
                          {deliveryMode === "pickup" && pickupTime && (
                            <div>Pickup: <strong>{new Date(pickupDate).toLocaleDateString()} at {formatTo12Hour(pickupTime)}</strong></div>
                          )}
                          {deliveryMode === "delivery" && deliveryTime && (
                            <div>Delivery: <strong>{new Date(deliveryDate).toLocaleDateString()} at {formatTo12Hour(deliveryTime)}</strong></div>
                          )}
                          {selectedPromoCode && (
                            <div>Promo Code: <strong>{selectedPromoCode}</strong></div>
                          )}
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Invoice Preview - Keep as is with proper formatting */}
                <div className="mb-4 mt-2">
                  <h5 className="mb-3 text-center">Qwik Bistro Invoice</h5>
                  <div className="d-flex justify-content-center">
                    <div
                      id="invoice"
                      className="custom-font-styles"
                      style={{
                        backgroundColor: "#fef1e8",
                        borderRadius: "10px",
                        boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                        width: "160mm",
                        height: "240mm",
                        padding: "50px",
                        paddingTop: "20px",
                      }}
                    >
                      {/* Invoice content remains the same as before */}
                      <div className="d-flex justify-content-center">
                        <img
                          style={{ margin: "0 auto" }}
                          height="100"
                          src={logoImg}
                          crossOrigin="anonymous"
                          alt="qwik-bistro-1-Qwik-Bistro"
                          width="100"
                        />
                      </div>

                      <div style={{ marginBottom: "16px" }}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: "16px",
                          }}
                        >
                          <div style={{ textAlign: "left", height: "80px" }}>
                            <p
                              style={{ fontSize: "15px", marginBottom: "0px" }}
                            >
                              Invoice to:
                            </p>
                            <p
                              style={{
                                fontSize: "14px",
                                paddingTop: "4px",
                                marginBottom: "0px",
                              }}
                            >
                              <span
                                style={{
                                  fontSize: "15px",
                                  fontWeight: "bold",
                                  color: "#e76f51",
                                }}
                              >
                                {orderData.invoiceTo}
                              </span>
                            </p>
                            {/* <p style={{ fontSize: "14px", paddingTop: "4px", marginBottom: "0px" }}>
                              <span style={{ fontSize: "14px" }}>
                                {orderData.companyinvoiceTo}
                              </span>
                            </p> */}
                            {/* {deliveryMode === "delivery" && ( */}
                            <p
                              style={{
                                fontSize: "14px",
                                paddingTop: "4px",
                                marginBottom: "0px",
                              }}
                            >
                              <span style={{ fontSize: "14px" }}>
                                {deliveryMode === "delivery"
                                  ? deliveryAddress
                                  : pickupAddress}
                              </span>
                            </p>
                            {/* )} */}
                          </div>
                          <div style={{ textAlign: "right" }}>
                            <p
                              style={{ fontSize: "14px", marginBottom: "0px" }}
                            >
                              Invoice # <span>{orderData.invoiceNumber}</span>
                            </p>
                            <p
                              style={{
                                fontSize: "14px",
                                paddingTop: "4px",
                                marginBottom: "0px",
                              }}
                            >
                              Date:{" "}
                              <span>
                                {new Date(
                                  orderData.invoiceDate,
                                ).toLocaleDateString("en-CA", {
                                  year: "numeric",
                                  month: "long",
                                  day: "numeric",
                                })}
                              </span>
                            </p>
                            <p
                              style={{
                                fontSize: "14px",
                                paddingTop: "4px",
                                marginBottom: "0px",
                              }}
                            >
                              {/* {deliveryMode === "pickup" ? "Pickup" : "Delivery"}:{" "} */}
                              Delivery mode:{" "}
                              <span>
                                {/* {deliveryMode === "pickup" 
                                  ? new Date(pickupDate).toLocaleDateString("en-CA", { year: "numeric", month: "long", day: "numeric" })
                                  : new Date(deliveryDate).toLocaleDateString("en-CA", { year: "numeric", month: "long", day: "numeric" })
                                } */}
                                {deliveryMode == "pickup"
                                  ? "Pickup"
                                  : "Delivery"}
                              </span>
                            </p>
                            {/* <p style={{ fontSize: "14px", marginBottom: "0px" }}>
                              {deliveryMode === "pickup" ? "Pickup Time" : "Delivery Time"}:{" "}
                              <span>
                                {deliveryMode === "pickup" ? formatTo12Hour(pickupTime) : formatTo12Hour(deliveryTime)}
                              </span>
                            </p> */}
                          </div>
                        </div>
                      </div>

                      <div style={{ borderTop: "1px dashed #e76f51" }} />

                      <div
                        style={{
                          marginTop: "0px",
                          marginBottom: "0px",
                          // height: "396px"
                          height: "356px",
                        }}
                      >
                        <div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              fontWeight: 600,
                              fontSize: "13px",
                              marginTop: "8px",
                            }}
                          >
                            <p
                              style={{
                                flex: "0 0 46%",
                                textAlign: "left",
                                marginBottom: "0px",
                              }}
                            >
                              ITEM
                            </p>
                            <p
                              style={{
                                flex: "0 0 20%",
                                textAlign: "center",
                                marginBottom: "0px",
                              }}
                            >
                              UNIT PRICE
                            </p>
                            <p
                              style={{
                                flex: "0 0 16%",
                                textAlign: "center",
                                marginBottom: "0px",
                              }}
                            >
                              QNTY
                            </p>
                            <p
                              style={{
                                flex: "0 0 18%",
                                textAlign: "right",
                                marginBottom: "0px",
                              }}
                            >
                              PRICE
                            </p>
                          </div>

                          {items.map(item => (
                            <div
                              key={item.id}
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                fontSize: "13px",
                                marginTop: "9px",
                              }}
                            >
                              <p
                                style={{
                                  flex: "0 0 46%",
                                  textAlign: "left",
                                  marginBottom: "0px",
                                }}
                              >
                                {item.itemName}
                              </p>
                              <p
                                style={{
                                  flex: "0 0 20%",
                                  textAlign: "center",
                                  marginBottom: "0px",
                                }}
                              >
                                {item.price ? `$${item.price.toFixed(2)}` : "-"}
                              </p>
                              <p
                                style={{
                                  flex: "0 0 16%",
                                  textAlign: "center",
                                  marginBottom: "0px",
                                }}
                              >
                                {item.quantity == 0 ? "-" : item.quantity}
                              </p>
                              <p
                                style={{
                                  flex: "0 0 18%",
                                  textAlign: "right",
                                  marginBottom: "0px",
                                }}
                              >
                                $
                                {item?.manualTotal
                                  ? item?.manualTotal.toFixed(2)
                                  : (item.quantity * item.price).toFixed(2)}
                              </p>
                            </div>
                          ))}
                        </div>
                      </div>

                      <div>
                        <div style={{ borderTop: "1px dashed #e76f51" }} />

                        <div style={{ marginTop: "5px", textAlign: "right" }}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              width: "70%",
                              marginLeft: "150px",
                              fontSize: "14px",
                            }}
                          >
                            <p
                              style={{
                                flex: "0 0 70%",
                                textAlign: "right",
                                width: "60%",
                                paddingLeft: "10px",
                                marginBottom: "0px",
                              }}
                            >
                              Subtotal:
                            </p>
                            <p
                              style={{
                                flex: "0 0 30%",
                                textAlign: "right",
                                width: "40%",
                                marginBottom: "0px",
                              }}
                            >
                              ${totals.subtotal.toFixed(2)}
                            </p>
                          </div>

                          {totals.discountAmount > 0 && (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginTop: "4px",
                                width: "70%",
                                marginLeft: "150px",
                                fontSize: "14px",
                              }}
                            >
                              <p
                                style={{
                                  flex: "0 0 70%",
                                  textAlign: "right",
                                  paddingLeft: "10px",
                                  marginBottom: "0px",
                                }}
                              >
                                Discount:
                              </p>
                              <p
                                style={{
                                  flex: "0 0 30%",
                                  textAlign: "right",
                                  width: "40%",
                                  color: "#01a859",
                                  marginBottom: "0px",
                                }}
                              >
                                - ${totals.discountAmount.toFixed(2)}
                              </p>
                            </div>
                          )}

                          {deliveryMode === "delivery" &&
                            totals.delivery > 0 && (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  marginTop: "4px",
                                  width: "70%",
                                  marginLeft: "150px",
                                  fontSize: "14px",
                                }}
                              >
                                <p
                                  style={{
                                    flex: "0 0 70%",
                                    textAlign: "right",
                                    paddingLeft: "10px",
                                    marginBottom: "0px",
                                  }}
                                >
                                  Delivery Fee:
                                </p>
                                <p
                                  style={{
                                    flex: "0 0 30%",
                                    textAlign: "right",
                                    width: "40%",
                                    marginBottom: "0px",
                                  }}
                                >
                                  ${totals.delivery.toFixed(2)}
                                </p>
                              </div>
                            )}

                          {totals.hstAmount > 0 && (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginTop: "4px",
                                width: "70%",
                                marginLeft: "150px",
                                fontSize: "14px",
                              }}
                            >
                              <p
                                style={{
                                  flex: "0 0 70%",
                                  textAlign: "right",
                                  paddingLeft: "10px",
                                  marginBottom: "0px",
                                }}
                              >
                                Tax (HST {hstPercentage}%):
                              </p>
                              <p
                                style={{
                                  flex: "0 0 30%",
                                  textAlign: "right",
                                  width: "40%",
                                  marginBottom: "0px",
                                }}
                              >
                                ${totals.hstAmount.toFixed(2)}
                              </p>
                            </div>
                          )}

                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              fontWeight: "bold",
                              marginTop: "4px",
                              width: "70%",
                              marginLeft: "150px",
                            }}
                          >
                            <p
                              style={{
                                flex: "0 0 70%",
                                textAlign: "right",
                                paddingLeft: "10px",
                                fontSize: "14px",
                                marginBottom: "0px",
                              }}
                            >
                              Total:
                            </p>
                            <p
                              style={{
                                flex: "0 0 30%",
                                textAlign: "right",
                                fontSize: "14px",
                                marginBottom: "0px",
                              }}
                            >
                              ${totals.total.toFixed(2)}
                            </p>
                          </div>
                        </div>

                        <div
                          style={{
                            fontSize: "13px",
                            marginTop: "20px",
                            textAlign: "left",
                          }}
                        >
                          <p
                            style={{
                              fontWeight: "bold",
                              fontSize: "12px",
                              marginBottom: "0px",
                            }}
                          >
                            Payment Method:
                          </p>
                          <p style={{ fontSize: "12px", marginBottom: "0px" }}>
                            Interac e-Transfer:{" "}
                            <span style={{ fontWeight: "bold" }}>
                              {orderData.transfer}
                            </span>
                          </p>
                          {/* <p style={{ fontSize: "12px", marginBottom: "0px" }}>
                            {deliveryMode === "pickup" ? "Pickup" : "Delivery"}:{" "}
                            <span style={{ fontWeight: "bold" }}>
                              {deliveryMode === "pickup" 
                                ? `${new Date(pickupDate).toLocaleDateString()} at ${formatTo12Hour(pickupTime)}`
                                : `${new Date(deliveryDate).toLocaleDateString()} at ${formatTo12Hour(deliveryTime)}`
                              }
                            </span>
                          </p> */}
                        </div>

                        <div
                          className="mt-3"
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            fontSize: "13px",
                          }}
                        >
                          <p
                            style={{
                              color: "#e76f51",
                              fontWeight: 700,
                              marginBottom: "0px",
                            }}
                          >
                            (506) 899-3939
                          </p>
                          <p
                            style={{
                              color: "#e76f51",
                              fontWeight: 700,
                              marginBottom: "0px",
                            }}
                          >
                            qwikbistro.ca
                          </p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            fontSize: "13px",
                          }}
                        >
                          <p
                            style={{
                              fontSize: "x-small",
                              fontWeight: 400,
                              color: "#000000",
                              marginBottom: "0px",
                            }}
                          >
                            NB Reg # 726813942NP0001
                          </p>
                          <p
                            style={{
                              fontSize: "x-small",
                              fontWeight: 400,
                              color: "#000000",
                              marginBottom: "0px",
                            }}
                          >
                            Managing Food Safety Certificate # 32234402
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="row mt-4">
                  <div className="col-12">
                    <div className="d-flex justify-content-center">
                      <div className="d-flex gap-2">
                        <button
                          type="button"
                          className="btn btn-success"
                          onClick={saveOrder}
                          disabled={isSubmitting || items.length === 0}
                        >
                          {isSubmitting ? (
                            <>
                              <i className="fas fa-spinner fa-spin me-1"></i>
                              Saving...
                            </>
                          ) : (
                            <>
                              <i className="fas fa-save me-1"></i>
                              Save Order
                            </>
                          )}
                        </button>

                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={generatePDF}
                          disabled={items.length === 0}
                        >
                          <i className="fas fa-download me-1"></i>
                          Download PDF
                        </button>

                        <button
                          type="button"
                          className="btn btn-warning"
                          onClick={handleSendInvoice}
                          disabled={
                            isSending || items.length === 0 || !orderData.email
                          }
                        >
                          {isSending ? (
                            <>
                              <i className="fas fa-spinner fa-spin me-1"></i>
                              Sending...
                            </>
                          ) : (
                            <>
                              <i className="fas fa-envelope me-1"></i>
                              Send Invoice
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modals */}
      <Modal
        isOpen={modal.show}
        onClose={() => setModal({ ...modal, show: false })}
        title={modal.title}
      >
        {modal.message}
      </Modal>

      {/* Combo Modal */}
      {showComboModal && currentComboItem && (
        <ComboItemModal
          item={currentComboItem}
          onCancel={handleComboCancel}
          onSubmit={handleComboSubmit}
        />
      )}

      <CreateCustomerModal
        isOpen={showCreateCustomerModal}
        onClose={() => setShowCreateCustomerModal(false)}
        onSuccess={handleCustomerCreated}
      />
    </div>
  )
}

// Combo Item Modal Component (keep as is)
const ComboItemModal = ({ item, onCancel, onSubmit }) => {
  const [selections, setSelections] = useState(() => {
    const initialSelections = {}
    if (item?.combo_structure?.[0]?.choice_groups) {
      item.combo_structure[0].choice_groups.forEach(group => {
        initialSelections[group.title] = group.default
      })
    }
    return initialSelections
  })

  const handleSelectionChange = (groupTitle, option) => {
    setSelections(prev => ({
      ...prev,
      [groupTitle]: option,
    }))
  }

  const handleSubmit = () => {
    if (!item.combo_structure?.[0]) return

    const fixedItems = item.combo_structure[0].fixed_items
    const chosenItems = Object.values(selections)

    let description = `${item?.item_name} - `
    fixedItems.forEach((item, index) => {
      description += `${index + 1}. ${item} `
    })
    chosenItems.forEach((item, index) => {
      description += `${fixedItems.length + index + 1}. ${item} `
    })

    onSubmit(description)
  }

  return (
    <div
      className="modal fade show d-block"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{item?.item_name}</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onCancel}
            ></button>
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <p className="text-danger fs-5 fw-bold">Price: ${item?.price}</p>
            </div>

            {item?.combo_structure?.[0]?.fixed_items && (
              <div className="mb-4">
                <h6 className="fw-bold">Fixed Items:</h6>
                <ul className="list-group">
                  {item.combo_structure[0].fixed_items.map((item, index) => (
                    <li key={index} className="list-group-item">
                      {index + 1}. {item}
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {item?.combo_structure?.[0]?.choice_groups && (
              <div className="mb-4">
                <h6 className="fw-bold mb-3">Customize:</h6>
                <div className="row">
                  {item.combo_structure[0].choice_groups.map((group, index) => (
                    <div key={index} className="col-md-6 mb-3">
                      <h6 className="fw-semibold mb-2">{group.title}</h6>
                      <div className="form-group">
                        {group.options.map((option, optIndex) => (
                          <div key={optIndex} className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name={group.title}
                              id={`${group.title}-${optIndex}`}
                              value={option}
                              checked={selections[group.title] === option}
                              onChange={() =>
                                handleSelectionChange(group.title, option)
                              }
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`${group.title}-${optIndex}`}
                            >
                              {option}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onCancel}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-success"
              onClick={handleSubmit}
            >
              Add to Order
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CreateQwikBistroOrderPage

// import React, { useState, useEffect, useMemo } from "react";
// import { useNavigate } from "react-router-dom";
// import { toast } from "sonner";
// import Breadcrumb from "components/Common/Breadcrumb";
// import DashboardLoader from "components/Loader/DashboardLoader";
// import { jsPDF } from "jspdf";
// import html2canvas from "html2canvas";
// import emailjs from "@emailjs/browser";
// // import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
// // import EmailIcon from "@mui/icons-material/Email";
// import logoImg from "../../assets/images/QwikBistro.png";
// import CreateCustomerModal from "pages/Customers/CreateCustomerModal";

// // Create API service for orders
// const orderApiService = {
//   // Get all orders
//   getAllOrders: async () => {
//     try {
//       const response = await fetch("http://127.0.0.1:8000/order/", {
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${process.env.REACT_APP_QWIKBISTRO_TOKEN}`,
//         },
//       });
//       const data = await response.json();
//       return data.reverse(); // Reverse to show latest first
//     } catch (error) {
//       console.error('Error fetching orders:', error);
//       throw error;
//     }
//   },

//   // Create new order
//   createOrder: async (orderData) => {
//     try {
//       const response = await fetch("http://127.0.0.1:8000/order/new", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${process.env.REACT_APP_QWIKBISTRO_TOKEN}`,
//         },
//         body: JSON.stringify(orderData),
//       });

//       if (!response.ok) {
//         throw new Error("Failed to save order");
//       }

//       return await response.json();
//     } catch (error) {
//       console.error('Error creating order:', error);
//       throw error;
//     }
//   },

//   // Get menu items
//   getMenuItems: async () => {
//     try {
//       const response = await fetch("http://127.0.0.1:8000/menuItem/", {
//         headers: {
//           Authorization: `Bearer ${process.env.REACT_APP_QWIKBISTRO_TOKEN}`,
//         },
//       });
//       return await response.json();
//     } catch (error) {
//       console.error('Error fetching menu items:', error);
//       throw error;
//     }
//   },

//   getAllUsers: async () => {
//     try {
//       const response = await fetch("http://127.0.0.1:8000/userProfile/", {
//         headers: {
//           Authorization: `Bearer ${process.env.REACT_APP_QWIKBISTRO_TOKEN}`,
//         },
//       });
//       return await response.json();
//     } catch (error) {
//       console.error('Error fetching menu items:', error);
//       throw error;
//     }
//   },

//   // Search users
//   searchUsers: async (query) => {
//     try {
//       const response = await fetch(
//         `http://127.0.0.1:8000/userProfile/?search=${query}`,
//         {
//           headers: {
//             Authorization: `Bearer ${process.env.REACT_APP_QWIKBISTRO_TOKEN}`,
//           },
//         }
//       );
//       return await response.json();
//     } catch (error) {
//       console.error('Error searching users:', error);
//       throw error;
//     }
//   },

//   // Create transaction
//   createTransaction: async (transactionData) => {
//     try {
//       const response = await fetch(
//         "http://127.0.0.1:8000/transaction/new",
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${process.env.REACT_APP_QWIKBISTRO_TOKEN}`,
//           },
//           body: JSON.stringify(transactionData),
//         }
//       );
//       return await response.json();
//     } catch (error) {
//       console.error('Error creating transaction:', error);
//       throw error;
//     }
//   },
// };

// const CreateQwikBistroOrderPage = () => {
//   const navigate = useNavigate();
//   const [isUserSelected, setIsUserSelected] = useState(false);

//   const [showCreateCustomerModal, setShowCreateCustomerModal] = useState(false);

//   const [isLoading, setIsLoading] = useState(true);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [menuItems, setMenuItems] = useState([]);
//   const [users, setUsers] = useState([]);
//   const [userLoading, setUserLoading] = useState(false);
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [items, setItems] = useState([]);
//   const [lastBalance, setLastBalance] = useState(0);
//   const [showComboModal, setShowComboModal] = useState(false);
//   const [currentComboItem, setCurrentComboItem] = useState(null);
//   const [currentItemId, setCurrentItemId] = useState(null);
//   const [isSending, setIsSending] = useState(false);

//   // Initialize order data
//   const [orderData, setOrderData] = useState({
//     invoiceTo: "",
//     companyinvoiceTo: "",
//     invoiceNumber: "",
//     email: "",
//     phone: "",
//     paidamount: "",
//     tips: "",
//     receivedby: "",
//     paymentdate: "",
//     invoiceDate: new Date().toISOString().split("T")[0],
//     transfer: "m7thun@gmail.com",
//     discount: "0",
//     deliveryFee: "3",
//     user_id: "",
//     qb_user_id: "",
//   });

//   const [totals, setTotals] = useState({
//     subtotal: 0,
//     discountAmount: 0,
//     delivery: 0,
//     total: 0,
//   });

//   const [modal, setModal] = useState({
//     show: false,
//     title: "",
//     message: "",
//   });

//   const [allUsers, setAllUsers] = useState([]);

//   // Fetch initial data
//   const fetchInitialData = async () => {
//     try {
//       const usersData = await orderApiService.getAllUsers();
//       setAllUsers(usersData);

//       // Fetch orders to get next ID
//       const orders = await orderApiService.getAllOrders();
//       const formatCustomerId = (id) => {
//         return `QB-25-${String(id).padStart(4, "0")}`;
//       };
//       const nextId = formatCustomerId(orders.length + 1);

//       setOrderData(prev => ({
//         ...prev,
//         invoiceNumber: nextId,
//       }));

//       // Fetch menu items
//       const menuData = await orderApiService.getMenuItems();
//       setMenuItems(menuData);

//       // Fetch last transaction balance
//       await fetchLastBalance();

//     } catch (error) {
//       toast.error("Failed to load initial data");
//       console.error("Error loading data:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchInitialData();
//   }, []);

//   const fetchLastBalance = async () => {
//     try {
//       const response = await fetch("http://127.0.0.1:8000/transaction/", {
//         headers: {
//           Authorization: `Bearer ${process.env.REACT_APP_QWIKBISTRO_TOKEN}`,
//         },
//       });

//       if (!response.ok) throw new Error("Failed to fetch transactions");

//       const data = await response.json();
//       let lastBalance = 0;

//       if (data && data.length > 0) {
//         const sortedTransactions = [...data].sort(
//           (a, b) =>
//             new Date(b.systemdate || b.date) - new Date(a.systemdate || a.date)
//         );

//         const lastTransactionWithBalance = sortedTransactions.find(
//           (t) =>
//             t.balance !== null && t.balance !== undefined && t.balance !== ""
//         );

//         if (lastTransactionWithBalance) {
//           lastBalance = parseFloat(lastTransactionWithBalance.balance) || 0;
//         }
//       }

//       setLastBalance(lastBalance);
//     } catch (err) {
//       console.error("Error fetching balance:", err);
//       setLastBalance(0);
//     }
//   };

//   // Search users
//   // useEffect(() => {
//   //   const searchUsers = async () => {
//   //     if (searchTerm.length < 2) {
//   //       setUsers([]);
//   //       return;
//   //     }

//   //     setUserLoading(true);
//   //     // try {
//   //     //   const data = await orderApiService.searchUsers(searchTerm);
//   //     //   setUsers(data);
//   //     // } catch (error) {
//   //     //   console.error("Error searching users:", error);
//   //     // } finally {
//   //     //   setUserLoading(false);
//   //     // }
//   //     try {
//   //       const data = await orderApiService.searchUsers(searchTerm);

//   //       // Only set users if data exists and is not empty
//   //       if (data && data.length > 0) {
//   //         setUsers(data);
//   //       } else {
//   //         setUsers([]);
//   //       }
//   //     } catch (error) {
//   //       console.error("Error searching users:", error);
//   //       setUsers([]); // Clear users on error too
//   //     } finally {
//   //       setUserLoading(false);
//   //     }

//   //   };

//   //   const debounceTimer = setTimeout(searchUsers, 300);
//   //   return () => clearTimeout(debounceTimer);
//   // }, [searchTerm]);

//   // Search users - Updated Code
//   // useEffect(() => {
//   //   const searchUsers = async () => {
//   //     if (searchTerm.length < 2) {
//   //       setUsers([]);
//   //       return;
//   //     }

//   //     setUserLoading(true);
//   //     try {
//   //       const data = await orderApiService.searchUsers(searchTerm);

//   //       // Only set users if data exists and is not empty
//   //       if (data && data.length > 0) {
//   //         setUsers(data);
//   //       } else {
//   //         setUsers([]);
//   //       }
//   //     } catch (error) {
//   //       console.error("Error searching users:", error);
//   //       setUsers([]); // Clear users on error too
//   //     } finally {
//   //       setUserLoading(false);
//   //     }
//   //   };

//   //   const debounceTimer = setTimeout(searchUsers, 300);
//   //   return () => clearTimeout(debounceTimer);
//   // }, [searchTerm]);

//   // useEffect(() => {
//   //   const searchUsers = async () => {
//   //     // Don't search if user has been selected or search term is too short
//   //     if (isUserSelected || searchTerm.length < 2) {
//   //       if (searchTerm.length < 2) {
//   //         setUsers([]);
//   //       }
//   //       return;
//   //     }

//   //     setUserLoading(true);
//   //     try {
//   //       const data = await orderApiService.searchUsers(searchTerm);

//   //       // Only set users if data exists and is not empty
//   //       if (data && data.length > 0) {
//   //         setUsers(data);
//   //       } else {
//   //         setUsers([]);
//   //       }
//   //     } catch (error) {
//   //       console.error("Error searching users:", error);
//   //       setUsers([]); // Clear users on error too
//   //     } finally {
//   //       setUserLoading(false);
//   //     }
//   //   };

//   //   const debounceTimer = setTimeout(searchUsers, 300);
//   //   return () => clearTimeout(debounceTimer);
//   // }, [searchTerm, isUserSelected]); // Add isUserSelected to dependency array
//   useEffect(() => {
//     if (searchTerm.length < 2) {
//       setUsers([]);
//       return;
//     }

//     setUserLoading(true);

//     const debounceTimer = setTimeout(() => {
//       const filteredUsers = allUsers.filter(user =>
//         user.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         user.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         user.phone?.includes(searchTerm) ||
//         user.qb_user_id?.toString().includes(searchTerm)
//       );

//       setUsers(filteredUsers);
//       setUserLoading(false);
//     }, 300);

//     return () => clearTimeout(debounceTimer);
//   }, [searchTerm, allUsers]);

//   // Calculate totals
//   useEffect(() => {
//     calculateTotal();
//   }, [items, orderData.discount, orderData.deliveryFee]);

//   // Handlers
//   const handleInputChange = (field, value) => {
//     setOrderData(prev => ({ ...prev, [field]: value }));
//   };

//   const addItem = () => {
//     setItems(prev => [
//       ...prev,
//       {
//         id: Date.now(),
//         itemName: "",
//         quantity: 1,
//         price: 0,
//         total: 0,
//         manualTotal: null,
//       },
//     ]);
//   };

//   const removeItem = (id) => {
//     setItems(prev => prev.filter(item => item.id !== id));
//   };

//   const updateItem = (id, field, value) => {
//     setItems(prev =>
//       prev.map(item => {
//         if (item.id === id) {
//           const updatedItem = { ...item, [field]: value };

//           if (field === "itemName") {
//             const matchedItem = menuItems.find(
//               menuItem => menuItem.item_name === value
//             );

//             if (matchedItem) {
//               if (matchedItem.is_combo) {
//                 setTimeout(() => {
//                   setShowComboModal(true);
//                   setCurrentComboItem(matchedItem);
//                   setCurrentItemId(id);
//                 }, 0);
//                 return item;
//               }

//               updatedItem.price = parseFloat(matchedItem.price) || 0;
//               updatedItem.manualTotal = null;
//             } else {
//               updatedItem.price = 0;
//               updatedItem.manualTotal = null;
//             }
//           }

//           if (field === "total") {
//             updatedItem.manualTotal = parseFloat(value) || 0;
//             return updatedItem;
//           }

//           if (field === "quantity" || field === "price") {
//             const quantity = parseInt(updatedItem.quantity) || 0;
//             const price = parseFloat(updatedItem.price) || 0;
//             updatedItem.total = quantity * price;
//             updatedItem.manualTotal = null;
//           }

//           return updatedItem;
//         }
//         return item;
//       })
//     );
//   };

//   const calculateTotal = () => {
//     const subtotal = items.reduce(
//       (sum, item) =>
//         sum +
//         (item.manualTotal !== null
//           ? item.manualTotal
//           : (item.quantity || 0) * (item.price || 0)),
//       0
//     );

//     const discount = parseFloat(orderData.discount) || 0;
//     const discountAmount = (discount / 100) * subtotal;
//     const deliveryFee = parseFloat(orderData.deliveryFee) || 0;
//     const total = subtotal - discountAmount + deliveryFee;

//     setTotals({
//       subtotal,
//       discountAmount,
//       delivery: deliveryFee,
//       total,
//     });
//   };

//   // Handler for when customer is created successfully
//   const handleCustomerCreated = (customer) => {
//     console.log("New customer created:", customer);
//     fetchInitialData();

//     handleUserSelect(customer);
//     // Refresh your customers list or update state
//   };

//   // const handleUserSelect = (user) => {
//   //   setSelectedUser(user);
//   //   if (user) {
//   //     setOrderData(prev => ({
//   //       ...prev,
//   //       invoiceTo: user.name || "",
//   //       companyinvoiceTo: user.address || "",
//   //       email: user.email || "",
//   //       phone: user.phone || "",
//   //       user_id: user.id || "",
//   //       qb_user_id: user.qb_user_id || "",
//   //     }));
//   //     setSearchTerm(user.qb_user_id);
//   //   } else {
//   //     setOrderData(prev => ({
//   //       ...prev,
//   //       invoiceTo: "",
//   //       companyinvoiceTo: "",
//   //       email: "",
//   //       phone: "",
//   //     }));
//   //     setSearchTerm("");
//   //   }
//   // };

//   const handleUserSelect = (user) => {
//     setSelectedUser(user);
//     setIsUserSelected(true); // Mark that user has been selected

//     if (user) {
//       setOrderData(prev => ({
//         ...prev,
//         invoiceTo: user.name || "",
//         companyinvoiceTo: user.address || "",
//         email: user.email || "",
//         phone: user.phone || "",
//         user_id: user.id || "",
//         qb_user_id: user.qb_user_id || "",
//       }));
//       // setSearchTerm(user.qb_user_id || ""); // Show user name instead of ID
//       setSearchTerm(user ? `${user.name} (${user.qb_user_id})` : "");
//       setUsers([]); // Clear the users dropdown immediately
//     } else {
//       setOrderData(prev => ({
//         ...prev,
//         invoiceTo: "",
//         companyinvoiceTo: "",
//         email: "",
//         phone: "",
//       }));
//       setSearchTerm("");
//       setIsUserSelected(false);
//     }
//   };

//   const saveOrder = async () => {
//     if (totals.total <= 0) {
//       setModal({
//         show: true,
//         title: "Validation Error",
//         message: "Please add items and calculate total first.",
//       });
//       return;
//     }

//     const confirmSave = window.confirm("Do you want to save this order to the database?");
//     if (!confirmSave) return;

//     setIsSubmitting(true);
//     try {
//       // Map items
//       const orderProducts = items.map(item => {
//         const menuItem = menuItems.find(
//           menuItem => menuItem.item_name === item.itemName
//         );

//         const totalPrice = item.manualTotal !== null
//           ? item.manualTotal
//           : (item.quantity || 0) * (item.price || 0);

//         return menuItem ? {
//           id: menuItem.id,
//           name: item.itemName,
//           price: item.price,
//           totalPrice: totalPrice,
//           quantity: item.quantity,
//           image: menuItem.image1,
//           vat: item.vat || "0",
//           discount: item.discount || "0",
//         } : {
//           id: Date.now(),
//           name: item.itemName,
//           price: item.price || 0,
//           totalPrice: totalPrice,
//           quantity: item.quantity,
//           image: "",
//           vat: item.vat || "0",
//           discount: item.discount || "0",
//         };
//       });

//       const orderPayload = {
//         user_id: orderData.user_id || "",
//         qb_user_id: orderData.qb_user_id || "",
//         order_date: orderData.invoiceDate,
//         user_email: orderData.email,
//         total_amount: totals.total.toFixed(2),
//         status: "pending",
//         payment_method: "e-Transfer",
//         payment_status: "not paid",
//         username: orderData.invoiceTo,
//         address: orderData.companyinvoiceTo,
//         totalprice: totals.total.toFixed(2),
//         deliverycharge: orderData.deliveryFee,
//         interac_e_transfer: orderData.transfer,
//         orderproductdata: orderProducts,
//         phonenumber: orderData.phone,
//         paidamount: orderData.paidamount || "",
//         tips: orderData.tips || "",
//         receivedby: orderData.receivedby || "",
//         paymentdate: orderData.paymentdate || "",
//         qb_order_id: orderData.invoiceNumber || "",
//       };

//       // Save order
//       const savedOrder = await orderApiService.createOrder(orderPayload);

//       // Create transaction
//       const totalAmount = parseFloat(savedOrder?.total_amount) || 0;
//       const transactionData = {
//         qb_user_id: savedOrder?.qb_user_id || "",
//         system_user_id: savedOrder?.user_id || "",
//         date: new Date().toISOString().split("T")[0],
//         qb_order_id: savedOrder?.qb_order_id || "",
//         system_order_id: savedOrder?.id || "",
//         total: savedOrder?.total_amount || "",
//         tips: 0,
//         balance: lastBalance + totalAmount,
//       };

//       await orderApiService.createTransaction(transactionData);

//       toast.success("Order created successfully");

//       // Navigate after delay
//       setTimeout(() => {
//         navigate("/all-qwikbistro-orders");
//       }, 1500);

//     } catch (error) {
//       console.error("Error saving order:", error);
//       toast.error("Failed to save order");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const generatePDF = async () => {
//     if (totals.total <= 0) {
//       setModal({
//         show: true,
//         title: "Validation Error",
//         message: "Please add items and calculate total first.",
//       });
//       return;
//     }

//     const input = document.getElementById("invoice");
//     html2canvas(input, {
//       scale: 2,
//       dpi: 300,
//       letterRendering: true,
//     }).then((canvas) => {
//       const imgData = canvas.toDataURL("image/jpeg", 1.0);
//       const pdf = new jsPDF("p", "mm", "a4");
//       const imgWidth = 210;
//       const imgHeight = (canvas.height * imgWidth) / canvas.width;

//       pdf.addImage(imgData, "JPEG", 0, 0, imgWidth, imgHeight);
//       pdf.save(
//         `Qwik_Bistro_Invoice_${orderData.invoiceNumber || "order"}.pdf`
//       );
//     });
//   };

//   const handleSendInvoice = async () => {
//     console.log("order data", orderData);

//     if (!orderData.email.trim()) {
//       setModal({
//         show: true,
//         title: "Validation Error",
//         message: "Email address is required.",
//       });
//       return;
//     }

//     if (totals.total <= 0 || items.length === 0) {
//       setModal({
//         show: true,
//         title: "Validation Error",
//         message: "Please add at least one item and calculate total.",
//       });
//       return;
//     }

//     try {
//       setIsSending(true);
//       const emailHTML = generateEmailHTML();

//       if (emailHTML.length > 100000) {
//         throw new Error("Invoice content too large");
//       }

//       const templateParams = {
//         subject_name: "Qwik Bistro Order",
//         email: orderData.email || "",
//         to_name: orderData.invoiceTo,
//         invoice_html: emailHTML,
//         invoice_number: orderData.invoiceNumber || "N/A",
//         total_amount: totals.total.toFixed(2),
//         company_name: "Qwik Bistro",
//       };

//       await emailjs.send(
//         "service_qhz8vu9",
//         "template_mhctmyk",
//         templateParams,
//         "GOJnpBoj2QdmeSr6h"
//       );

//       toast.success(`Invoice #${orderData.invoiceNumber} sent successfully!`);
//     } catch (error) {
//       console.error("Error sending invoice:", error);
//       toast.error("Failed to send invoice");
//     } finally {
//       setIsSending(false);
//     }
//   };

//   // qwikbistro@gmail.com, order@qwikbistro.ca, {{email}}

//   const generateEmailHTML = () => {
//     const formattedDate = new Date(orderData.invoiceDate).toLocaleDateString("en-CA", {
//       year: "numeric",
//       month: "long",
//       day: "numeric",
//     });

//     const itemsRows = items
//       .map(
//         (item) => `
//       <tr>
//         <td style="padding:10px 10px;border-bottom:1px solid #eee;text-align:left;">${item.itemName}</td>
//         <td style="padding:10px 10px;border-bottom:1px solid #eee;text-align:center;">${item.price ? `$${item.price.toFixed(2)}` : "-"}</td>
//         <td style="padding:10px 10px;border-bottom:1px solid #eee;text-align:center;">${item.quantity == 0 ? "-" : item.quantity}</td>
//         <td style="padding:10px 10px;border-bottom:1px solid #eee;text-align:right;">$${item?.manualTotal
//             ? item?.manualTotal.toFixed(2)
//             : (item.quantity * item.price).toFixed(2)
//           }</td>
//       </tr>
//     `
//       )
//       .join("");

//     // return `
//     //   <div style="width:100%;max-width:800px;margin:0 auto;font-family:Arial,sans-serif;">
//     //     <!-- Your existing email HTML template -->
//     //     ${emailHTML}
//     //   </div>
//     // `;
//     return `
//     <div style="width:100%;max-width:800px;margin:0 auto;font-family:Arial,sans-serif;">
//       <table width="100%" cellpadding="0" cellspacing="0" border="0">
//         <tr>
//           <td align="center" style="padding:20px 0;">
//             <img src="https://res.cloudinary.com/dlaeldpqy/image/upload/v1748246850/QwikBistro_olrbbh.png" width="116" height="116" style="display:block;margin:0 auto;"/>
//           </td>
//         </tr>
//       </table>

//       <!-- Invoice Header -->
//       <table width="100%" cellpadding="0" cellspacing="0" style="margin-bottom:20px;">
//         <tr>
//           <td width="50%" valign="top" style="padding:10px;">
//             <p style="font-size:14px;margin:0 0 5px 0;">Invoice to:</p>
//             <p style="font-size:16px;font-weight:bold;color:#e76f51;margin:5px 0;">${orderData.invoiceTo}</p>
//             <p style="font-size:13px;margin:5px 0;">${orderData.companyinvoiceTo}</p>
//           </td>
//           <td width="50%" valign="top" style="padding:10px;text-align:right;">
//             <p style="font-size:13px;margin:5px 0;">Invoice # ${orderData.invoiceNumber}</p>
//             <p style="font-size:13px;margin:5px 0;">Date: ${formattedDate}</p>
//           </td>
//         </tr>
//       </table>

//       <!-- Divider -->
//       <table width="100%" cellpadding="0" cellspacing="0" style="border-top:1px dashed #e76f51;margin:20px 0;"></table>

//       <!-- Items Table -->
//       <table width="100%" cellpadding="0" cellspacing="0" style="margin-bottom:20px;">
//         <tr>
//           <td width="46%" style="padding:5px 8px;font-weight:bold;text-align:left;">ITEM</td>
//           <td width="20%" style="padding:5px 8px;font-weight:bold;text-align:center;">UNIT PRICE</td>
//           <td width="16%" style="padding:5px 8px;font-weight:bold;text-align:center;">QNTY</td>
//           <td width="18%" style="padding:5px 8px;font-weight:bold;text-align:right;">PRICE</td>
//         </tr>
//         ${itemsRows}
//       </table>

//       <!-- Divider -->
//       <table width="100%" cellpadding="0" cellspacing="0" style="border-top:1px dashed #e76f51;margin:20px 0;"></table>

//       <!-- Totals -->
//       <table width="100%" cellpadding="0" cellspacing="0">
//         <tr>
//           <td width="70%" style="text-align:right;padding:5px 10px;">Subtotal:</td>
//           <td width="30%" style="text-align:right;padding:5px 10px;">$${totals.subtotal.toFixed(2)}</td>
//         </tr>

//         ${totals.discountAmount > 0
//         ? `
//           <tr>
//             <td style="text-align:right;padding:5px 10px;">Discount (${orderData.discount}%):</td>
//             <td style="text-align:right;padding:5px 10px;color:#01a859;">- $${totals.discountAmount.toFixed(2)}</td>
//           </tr>
//         `
//         : ""
//       }

//         <tr>
//           <td style="text-align:right;padding:5px 10px;">Delivery Fee:</td>
//           <td style="text-align:right;padding:5px 10px;">$${totals.delivery.toFixed(2)}</td>
//         </tr>

//         <tr>
//           <td style="text-align:right;padding:5px 10px;font-weight:bold;">Total:</td>
//           <td style="text-align:right;padding:5px 10px;font-weight:bold;">$${totals.total.toFixed(2)}</td>
//         </tr>
//       </table>

//       <!-- Payment Method -->
//       <table width="100%" cellpadding="0" cellspacing="0" style="margin-top:20px;">
//         <tr>
//           <td style="padding:10px 0;">
//             <p style="font-weight:bold;margin:5px 0;">Payment Method:</p>
//             <p style="margin:5px 0;">Interac e-Transfer: <span style="font-weight:bold;">${orderData.transfer}</span></p>
//           </td>
//         </tr>
//       </table>

//       <!-- Footer -->
//       <table width="100%" cellpadding="0" cellspacing="0" style="margin-top:15px;">
//   <tr>
//     <td>
//       <!-- First line: Phone (left) and Website (right) -->
//       <table width="100%" cellpadding="0" cellspacing="0">
//         <tr>
//           <td width="50%" style="text-align:left;">
//             <p style="color:#e76f51;font-weight:700;margin:5px 0;">(506) 899-3939</p>
//           </td>
//           <td width="50%" style="text-align:right;">
//             <p style="color:#e76f51;font-weight:700;margin:5px 0;">qwikbistro.ca</p>
//           </td>
//         </tr>
//       </table>

//       <!-- Second line: Reg # (left) and Certificate (right) -->
//       <table width="100%" cellpadding="0" cellspacing="0">
//         <tr>
//           <td width="50%" style="text-align:left;">
//             <p style="font-size:11px;margin:5px 0;">NB Reg # 726813942NP0001</p>
//           </td>
//           <td width="50%" style="text-align:right;">
//             <p style="font-size:11px;margin:5px 0;">Managing Food Safety Certificate # 32234402</p>
//           </td>
//         </tr>
//       </table>
//     </td>
//   </tr>
// </table>
//     </div>
//   `;

//   };

//   // Modal component
//   const Modal = ({ isOpen, onClose, title, children }) => {
//     if (!isOpen) return null;

//     return (
//       <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">{title}</h5>
//               <button type="button" className="btn-close" onClick={onClose}></button>
//             </div>
//             <div className="modal-body">
//               {children}
//             </div>
//             <div className="modal-footer">
//               <button type="button" className="btn btn-primary" onClick={onClose}>
//                 OK
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   // Combo modal handlers
//   const handleComboSubmit = (description) => {
//     setItems(prev =>
//       prev.map(item => {
//         if (item.id === currentItemId) {
//           return {
//             ...item,
//             itemName: description,
//             price: parseFloat(currentComboItem.price) || 0,
//             total: (item.quantity || 1) * (parseFloat(currentComboItem.price) || 0),
//           };
//         }
//         return item;
//       })
//     );
//     setShowComboModal(false);
//     setCurrentComboItem(null);
//     setCurrentItemId(null);
//   };

//   const handleComboCancel = () => {
//     setShowComboModal(false);
//     setCurrentComboItem(null);
//     setCurrentItemId(null);
//   };

//   if (isLoading) {
//     return <DashboardLoader />;
//   }

//   return (
//     <div className="page-content"
//       style={{
//         fontFamily: "'Quicksand', sans-serif",
//       }}
//     >
//       <div className="container-fluid">
//         <Breadcrumb title="Orders" breadcrumbItem="Create New Order" />

//         <div className="row">
//           <div className="col-12">
//             <div className="card">
//               <div className="card-body">
//                 <div className="d-flex justify-content-between align-items-center mb-3">
//                   <h4 className="card-title mb-4">Create New Order</h4>
//                   <button
//                     onClick={() => setShowCreateCustomerModal(true)}
//                     className="btn btn-success"
//                   >
//                     <i className="fas fa-plus me-1"></i> Create New Customer
//                   </button>

//                 </div>

//                 {/* Order Information */}
//                 <div className="row mb-4">
//                   <div className="col-md-6">
//                     <div className="mb-3">
//                       <label className="form-label">Search Customer</label>
//                       <div className="position-relative">
//                         <input
//                           type="text"
//                           className="form-control"
//                           value={searchTerm}
//                           onChange={(e) => setSearchTerm(e.target.value)}
//                           placeholder="Search by name or user ID..."
//                         />

//                         {users.length > 0 && searchTerm.length >= 2 && (
//                           <div className="position-absolute w-100 bg-white border rounded shadow-lg mt-1 z-1"
//                             style={{ maxHeight: '200px', overflowY: 'auto' }}>
//                             {users.map(user => (
//                               <div
//                                 key={user.id}
//                                 className="p-2 border-bottom hover-bg-light cursor-pointer"
//                                 onClick={() => handleUserSelect(user)}
//                               >
//                                 <div className="d-flex justify-content-between">
//                                   <span>{user.name}</span>
//                                   <small className="text-muted">{user.qb_user_id}</small>
//                                 </div>
//                               </div>
//                             ))}
//                           </div>
//                         )}
//                         {users.length > 0 && searchTerm.length >= 2 && !userLoading ? (
//                           <div className="position-absolute w-100 bg-white border rounded shadow-lg mt-1 z-1"
//                             style={{ maxHeight: '200px', overflowY: 'auto' }}>
//                             {users.map(user => (
//                               <div
//                                 key={user.id}
//                                 className="p-2 border-bottom hover-bg-light cursor-pointer"
//                                 onClick={() => handleUserSelect(user)}
//                               >
//                                 <div className="d-flex justify-content-between">
//                                   <span>{user.name}</span>
//                                   <small className="text-muted">{user.qb_user_id}</small>
//                                 </div>
//                               </div>
//                             ))}
//                           </div>
//                         ) : searchTerm.length >= 2 && userLoading ? (
//                           <div className="position-absolute w-100 bg-white border rounded shadow-lg mt-1 z-1 p-2">
//                             <div className="text-center text-muted">
//                               <i className="fas fa-spinner fa-spin me-2"></i>
//                               Searching...
//                             </div>
//                           </div>
//                         )
//                           // :
//                           // searchTerm.length >= 2 && users.length === 0 && !userLoading ? (
//                           //   <div className="position-absolute w-100 bg-white border rounded shadow-lg mt-1 z-1 p-2">
//                           //     <div className="text-center text-muted">
//                           //       No users found
//                           //     </div>
//                           //   </div>

//                           // )
//                           : null}

//                       </div>
//                     </div>
//                   </div>
//                   {/* <div className="col-md-6">
//                     <div className="mb-3">
//                       <label className="form-label">Search Customer</label>
//                       <div className="position-relative">
//                         <input
//                           type="text"
//                           className="form-control"
//                           value={searchTerm}
//                           onChange={(e) => setSearchTerm(e.target.value)}
//                           placeholder="Search by name or user ID..."
//                         />

//                         {userLoading && (
//                           <div className="position-absolute end-0 top-50 translate-middle-y me-3">
//                             <i className="fas fa-spinner fa-spin text-muted"></i>
//                           </div>
//                         )}

//                         {users.length > 0 && searchTerm.length >= 2 && !userLoading ? (
//                           <div className="position-absolute w-100 bg-white border rounded shadow-lg mt-1 z-1"
//                             style={{ maxHeight: '200px', overflowY: 'auto' }}>
//                             {users.map(user => (
//                               <div
//                                 key={user.id}
//                                 className="p-2 border-bottom hover-bg-light cursor-pointer"
//                                 onClick={() => handleUserSelect(user)}
//                               >
//                                 <div className="d-flex justify-content-between">
//                                   <span>{user.name}</span>
//                                   <small className="text-muted">{user.qb_user_id}</small>
//                                 </div>
//                               </div>
//                             ))}
//                           </div>
//                         ) : searchTerm.length >= 2 && userLoading ? (
//                           <div className="position-absolute w-100 bg-white border rounded shadow-lg mt-1 z-1 p-2">
//                             <div className="text-center text-muted">
//                               <i className="fas fa-spinner fa-spin me-2"></i>
//                               Searching...
//                             </div>
//                           </div>
//                         ) : searchTerm.length >= 2 && users.length === 0 && !userLoading ? (
//                           <div className="position-absolute w-100 bg-white border rounded shadow-lg mt-1 z-1 p-2">
//                             <div className="text-center text-muted">
//                               No users found
//                             </div>
//                           </div>
//                         ) : null}
//                       </div>
//                     </div>
//                   </div> */}

//                   <div className="col-md-6">
//                     <div className="mb-3">
//                       <label className="form-label">Order ID *</label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         value={orderData.invoiceNumber}
//                         onChange={(e) => handleInputChange('invoiceNumber', e.target.value)}
//                         // readOnly
//                         required
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 {/* Customer Details */}
//                 <div className="row mb-4">
//                   <div className="col-md-4">
//                     <div className="mb-3">
//                       <label className="form-label">Customer Name *</label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         value={orderData.invoiceTo}
//                         onChange={(e) => handleInputChange('invoiceTo', e.target.value)}
//                         required
//                       />
//                     </div>
//                   </div>

//                   <div className="col-md-4">
//                     <div className="mb-3">
//                       <label className="form-label">Delivery Address *</label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         value={orderData.companyinvoiceTo}
//                         onChange={(e) => handleInputChange('companyinvoiceTo', e.target.value)}
//                         required
//                       />
//                     </div>
//                   </div>

//                   <div className="col-md-4">
//                     <div className="mb-3">
//                       <label className="form-label">Phone *</label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         value={orderData.phone}
//                         onChange={(e) => handleInputChange('phone', e.target.value)}
//                         required
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 <div className="row mb-4">
//                   <div className="col-md-4">
//                     <div className="mb-3">
//                       <label className="form-label">Email *</label>
//                       <input
//                         type="email"
//                         className="form-control"
//                         value={orderData.email}
//                         onChange={(e) => handleInputChange('email', e.target.value)}
//                         required
//                       />
//                     </div>
//                   </div>

//                   <div className="col-md-4">
//                     <div className="mb-3">
//                       <label className="form-label">Order Date</label>
//                       <input
//                         type="date"
//                         className="form-control"
//                         value={orderData.invoiceDate}
//                         onChange={(e) => handleInputChange('invoiceDate', e.target.value)}
//                       />
//                     </div>
//                   </div>

//                   <div className="col-md-4">
//                     <div className="mb-3">
//                       <label className="form-label">Interac E-Transfer</label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         value={orderData.transfer}
//                         onChange={(e) => handleInputChange('transfer', e.target.value)}
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 {/* Payment Details */}
//                 <div className="row mb-4">
//                   <div className="col-md-3">
//                     <div className="mb-3">
//                       <label className="form-label">Paid Amount</label>
//                       <input
//                         type="number"
//                         className="form-control"
//                         value={orderData.paidamount}
//                         onChange={(e) => handleInputChange('paidamount', e.target.value)}
//                         step="0.01"
//                       />
//                     </div>
//                   </div>

//                   <div className="col-md-3">
//                     <div className="mb-3">
//                       <label className="form-label">Tips</label>
//                       <input
//                         type="number"
//                         className="form-control"
//                         value={orderData.tips}
//                         onChange={(e) => handleInputChange('tips', e.target.value)}
//                         step="0.01"
//                       />
//                     </div>
//                   </div>

//                   <div className="col-md-3">
//                     <div className="mb-3">
//                       <label className="form-label">Received By</label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         value={orderData.receivedby}
//                         onChange={(e) => handleInputChange('receivedby', e.target.value)}
//                       />
//                     </div>
//                   </div>

//                   <div className="col-md-3">
//                     <div className="mb-3">
//                       <label className="form-label">Payment Date</label>
//                       <input
//                         type="date"
//                         className="form-control"
//                         value={orderData.paymentdate}
//                         onChange={(e) => handleInputChange('paymentdate', e.target.value)}
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 {/* Order Items Section */}
//                 <div className="mb-4">
//                   <div className="d-flex justify-content-between align-items-center mb-3">
//                     <h5 className="mb-0">Order Items</h5>
//                     <button
//                       type="button"
//                       className="btn btn-primary btn-sm"
//                       onClick={addItem}
//                     >
//                       <i className="fas fa-plus me-1"></i> Add Item
//                     </button>
//                   </div>

//                   {items.length > 0 ? (
//                     <div className="table-responsive">
//                       <table className="table table-bordered table-hover">
//                         <thead className="table-light">
//                           <tr>
//                             <th width="40%">Item</th>
//                             <th width="15%">Quantity</th>
//                             <th width="15%">Price</th>
//                             <th width="15%">Total</th>
//                             <th width="15%">Action</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {items.map((item) => (
//                             <tr key={item.id}>
//                               <td>
//                                 <input
//                                   list={`itemList-${item.id}`}
//                                   className="form-control form-control-sm"
//                                   value={item.itemName}
//                                   onChange={(e) => {
//                                     setItems(prev =>
//                                       prev.map(i =>
//                                         i.id === item.id
//                                           ? { ...i, itemName: e.target.value }
//                                           : i
//                                       )
//                                     );
//                                   }}
//                                   onBlur={(e) => {
//                                     updateItem(item.id, "itemName", e.target.value);
//                                   }}
//                                   placeholder="Type or select item"
//                                 />
//                                 <datalist id={`itemList-${item.id}`}>
//                                   {menuItems.map(menuItem => (
//                                     <option key={menuItem.id} value={menuItem.item_name} />
//                                   ))}
//                                 </datalist>
//                               </td>
//                               <td>
//                                 <input
//                                   type="number"
//                                   className="form-control form-control-sm"
//                                   value={item.quantity}
//                                   min="0"
//                                   step="0.01"
//                                   onChange={(e) => {
//                                     const value = parseFloat(e.target.value);
//                                     updateItem(
//                                       item.id,
//                                       "quantity",
//                                       isNaN(value) ? 0 : value
//                                     );
//                                   }}
//                                 />
//                               </td>
//                               <td>
//                                 <input
//                                   type="number"
//                                   className="form-control form-control-sm"
//                                   value={item.price}
//                                   min="0"
//                                   step="0.01"
//                                   onChange={(e) =>
//                                     updateItem(
//                                       item.id,
//                                       "price",
//                                       parseFloat(e.target.value) || 0
//                                     )
//                                   }
//                                 />
//                               </td>
//                               <td>
//                                 <input
//                                   type="number"
//                                   className="form-control form-control-sm"
//                                   value={
//                                     item.manualTotal !== null
//                                       ? item.manualTotal
//                                       : (item.quantity * item.price).toFixed(2)
//                                   }
//                                   onChange={(e) =>
//                                     updateItem(item.id, "total", e.target.value)
//                                   }
//                                   onFocus={(e) => e.target.select()}
//                                   step="0.01"
//                                   min="0"
//                                 />
//                               </td>
//                               <td className="text-center">
//                                 <button
//                                   type="button"
//                                   className="btn btn-danger btn-sm"
//                                   onClick={() => removeItem(item.id)}
//                                 >
//                                   <i className="fas fa-trash"></i>
//                                 </button>
//                               </td>
//                             </tr>
//                           ))}
//                         </tbody>
//                       </table>
//                     </div>
//                   ) : (
//                     <div className="alert alert-info text-center">
//                       No items added. Click "Add Item" to add order items.
//                     </div>
//                   )}
//                 </div>

//                 {/* Pricing & Calculation */}
//                 <div className="row mb-4">
//                   <div className="col-md-6">
//                     <div className="card">
//                       <div className="card-body">
//                         <h5 className="card-title mb-3">Pricing</h5>

//                         <div className="row mb-3">
//                           <div className="col-md-6">
//                             <label className="form-label">Discount (%)</label>
//                             <input
//                               type="number"
//                               className="form-control"
//                               value={orderData.discount}
//                               onChange={(e) => handleInputChange('discount', e.target.value)}
//                               step="0.01"
//                               min="0"
//                             />
//                           </div>
//                           <div className="col-md-6">
//                             <label className="form-label">Delivery Fee</label>
//                             <input
//                               type="number"
//                               className="form-control"
//                               value={orderData.deliveryFee}
//                               onChange={(e) => handleInputChange('deliveryFee', e.target.value)}
//                               step="0.01"
//                               min="0"
//                             />
//                           </div>
//                         </div>

//                         <div className="mt-3">
//                           <button
//                             type="button"
//                             className="btn btn-info w-100"
//                             onClick={calculateTotal}
//                           >
//                             <i className="fas fa-calculator me-1"></i> Calculate Total
//                           </button>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="col-md-6">
//                     <div className="card">
//                       <div className="card-body">
//                         <h5 className="card-title mb-3">Order Summary</h5>

//                         <div className="mb-2 d-flex justify-content-between">
//                           <span>Subtotal:</span>
//                           <span className="fw-semibold">${totals.subtotal.toFixed(2)}</span>
//                         </div>

//                         {totals.discountAmount > 0 && (
//                           <div className="mb-2 d-flex justify-content-between text-success">
//                             <span>Discount ({orderData.discount}%):</span>
//                             <span className="fw-semibold">-${totals.discountAmount.toFixed(2)}</span>
//                           </div>
//                         )}

//                         <div className="mb-2 d-flex justify-content-between">
//                           <span>Delivery Fee:</span>
//                           <span className="fw-semibold">${totals.delivery.toFixed(2)}</span>
//                         </div>

//                         <hr />

//                         <div className="d-flex justify-content-between">
//                           <span className="fw-bold">Total:</span>
//                           <span className="fw-bold fs-5">${totals.total.toFixed(2)}</span>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Invoice Preview (Keep original style) */}
//                 <div className="mb-4 mt-2">
//                   <h5 className="mb-3 text-center">Qwik Bistro Invoice</h5>
//                   <div className="d-flex justify-content-center">
//                     <div
//                       id="invoice"
//                       className="custom-font-styles"
//                       style={{
//                         backgroundColor: "#fef1e8",
//                         borderRadius: "10px",
//                         boxShadow: "0 0 10px rgba(0,0,0,0.1)",
//                         width: "160mm",
//                         height: "240mm",
//                         padding: "50px",
//                         paddingTop: "20px",
//                       }}
//                     >
//                       {/* Keep your original invoice HTML structure here */}
//                       <div className="d-flex justify-content-center">
//                         <img
//                           style={{ margin: "0 auto" }}
//                           height="100"
//                           src={logoImg}
//                           crossOrigin="anonymous"
//                           alt="qwik-bistro-1-Qwik-Bistro"
//                           width="100"
//                         />
//                       </div>

//                       <div style={{ marginBottom: "16px" }}>
//                         <div
//                           style={{
//                             display: "flex",
//                             justifyContent: "space-between",
//                             marginBottom: "16px",
//                           }}
//                         >
//                           <div style={{ textAlign: "left", height: "80px" }}>
//                             <p style={{ fontSize: "15px", marginBottom: "0px" }}>Invoice to:</p>
//                             <p style={{ fontSize: "14px", paddingTop: "4px", marginBottom: "0px" }}>
//                               <span
//                                 style={{
//                                   fontSize: "15px",
//                                   fontWeight: "bold",
//                                   color: "#e76f51",
//                                 }}
//                               >
//                                 {orderData.invoiceTo}
//                               </span>
//                             </p>
//                             <p style={{ fontSize: "14px", paddingTop: "4px", marginBottom: "0px" }}>
//                               <span style={{ fontSize: "14px" }}>
//                                 {orderData.companyinvoiceTo}
//                               </span>
//                             </p>
//                           </div>
//                           <div style={{ textAlign: "right" }}>
//                             <p style={{ fontSize: "14px", marginBottom: "0px" }}>
//                               Invoice # <span>{orderData.invoiceNumber}</span>
//                             </p>
//                             <p style={{ fontSize: "14px", paddingTop: "4px", marginBottom: "0px" }}>
//                               Date:{" "}
//                               <span>
//                                 {new Date(orderData.invoiceDate).toLocaleDateString("en-CA", {
//                                   year: "numeric",
//                                   month: "long",
//                                   day: "numeric",
//                                 })}
//                               </span>
//                             </p>
//                           </div>
//                         </div>
//                       </div>

//                       <div style={{ borderTop: "1px dashed #e76f51" }} />

//                       <div style={{ marginTop: "0px", marginBottom: "0px", height: "396px" }}>
//                         <div>
//                           <div style={{ display: "flex", justifyContent: "space-between", fontWeight: 600, fontSize: "13px", marginTop: "8px" }}>
//                             <p style={{ flex: "0 0 46%", textAlign: "left", marginBottom: "0px" }}>ITEM</p>
//                             <p style={{ flex: "0 0 20%", textAlign: "center", marginBottom: "0px" }}>UNIT PRICE</p>
//                             <p style={{ flex: "0 0 16%", textAlign: "center", marginBottom: "0px" }}>QNTY</p>
//                             <p style={{ flex: "0 0 18%", textAlign: "right", marginBottom: "0px" }}>PRICE</p>
//                           </div>

//                           {items.map((item) => (
//                             <div key={item.id} style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", marginTop: "9px" }}>
//                               <p style={{ flex: "0 0 46%", textAlign: "left", marginBottom: "0px" }}>{item.itemName}</p>
//                               <p style={{ flex: "0 0 20%", textAlign: "center", marginBottom: "0px" }}>
//                                 {item.price ? `$${item.price.toFixed(2)}` : "-"}
//                               </p>
//                               <p style={{ flex: "0 0 16%", textAlign: "center", marginBottom: "0px" }}>
//                                 {item.quantity == 0 ? "-" : item.quantity}
//                               </p>
//                               <p style={{ flex: "0 0 18%", textAlign: "right", marginBottom: "0px" }}>
//                                 ${item?.manualTotal
//                                   ? item?.manualTotal.toFixed(2)
//                                   : (item.quantity * item.price).toFixed(2)}
//                               </p>
//                             </div>
//                           ))}
//                         </div>
//                       </div>

//                       <div>
//                         <div style={{ borderTop: "1px dashed #e76f51" }} />

//                         <div style={{ marginTop: "5px", textAlign: "right" }}>
//                           {/* Total calculations (same as before) */}
//                           <div style={{ display: "flex", justifyContent: "space-between", width: "70%", marginLeft: "150px", fontSize: "14px" }}>
//                             <p style={{ flex: "0 0 70%", textAlign: "right", width: "60%", paddingLeft: "10px", marginBottom: "0px" }}>
//                               Subtotal:
//                             </p>
//                             <p style={{ flex: "0 0 30%", textAlign: "right", width: "40%", marginBottom: "0px" }}>
//                               ${totals.subtotal.toFixed(2)}
//                             </p>
//                           </div>

//                           {totals.discountAmount > 0 && (
//                             <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px", width: "70%", marginLeft: "150px", fontSize: "14px" }}>
//                               <p style={{ flex: "0 0 70%", textAlign: "right", paddingLeft: "10px", marginBottom: "0px" }}>
//                                 Discount (<span>{orderData.discount}</span>%):
//                               </p>
//                               <p style={{ flex: "0 0 30%", textAlign: "right", width: "40%", color: "#01a859", marginBottom: "0px" }}>
//                                 - ${totals.discountAmount.toFixed(2)}
//                               </p>
//                             </div>
//                           )}

//                           <div style={{ display: "flex", justifyContent: "space-between", marginTop: "4px", width: "70%", marginLeft: "150px", fontSize: "14px" }}>
//                             <p style={{ flex: "0 0 70%", textAlign: "right", paddingLeft: "10px", marginBottom: "0px" }}>
//                               Delivery Fee:
//                             </p>
//                             <p style={{ flex: "0 0 30%", textAlign: "right", width: "40%", marginBottom: "0px" }}>
//                               ${totals.delivery.toFixed(2)}
//                             </p>
//                           </div>

//                           <div style={{ display: "flex", justifyContent: "space-between", fontWeight: "bold", marginTop: "4px", width: "70%", marginLeft: "150px" }}>
//                             <p style={{ flex: "0 0 70%", textAlign: "right", paddingLeft: "10px", fontSize: "14px", marginBottom: "0px" }}>
//                               Total:
//                             </p>
//                             <p style={{ flex: "0 0 30%", textAlign: "right", fontSize: "14px", marginBottom: "0px" }}>
//                               ${totals.total.toFixed(2)}
//                             </p>
//                           </div>
//                         </div>

//                         <div style={{ fontSize: "13px", marginTop: "20px", textAlign: "left" }}>
//                           <p style={{ fontWeight: "bold", fontSize: "12px", marginBottom: "0px" }}>
//                             Payment Method:
//                           </p>
//                           <p style={{ fontSize: "12px", marginBottom: "0px" }}>
//                             Interac e-Transfer:{" "}
//                             <span style={{ fontWeight: "bold" }}>
//                               {orderData.transfer}
//                             </span>
//                           </p>
//                         </div>

//                         <div className="mt-3" style={{ display: "flex", justifyContent: "space-between", fontSize: "13px" }}>
//                           <p style={{ color: "#e76f51", fontWeight: 700, marginBottom: "0px" }}>
//                             (506) 899-3939
//                           </p>
//                           <p style={{ color: "#e76f51", fontWeight: 700, marginBottom: "0px" }}>qwikbistro.ca</p>
//                         </div>
//                         <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px" }}>
//                           <p style={{ fontSize: "x-small", fontWeight: 400, color: "#000000", marginBottom: "0px" }}>NB Reg # 726813942NP0001</p>
//                           <p style={{ fontSize: "x-small", fontWeight: 400, color: "#000000", marginBottom: "0px" }}>
//                             Managing Food Safety Certificate # 32234402
//                           </p>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Action Buttons */}
//                 <div className="row mt-4">
//                   <div className="col-12">
//                     <div className="d-flex justify-content-center">
//                       {/* <button
//                         type="button"
//                         className="btn btn-light"
//                         onClick={() => navigate("/orders")}
//                       >
//                         <i className="fas fa-arrow-left me-1"></i> Back to Orders
//                       </button> */}

//                       <div className="d-flex gap-2">
//                         <button
//                           type="button"
//                           className="btn btn-success"
//                           onClick={saveOrder}
//                           disabled={isSubmitting || items.length === 0}
//                         >
//                           {isSubmitting ? (
//                             <>
//                               <i className="fas fa-spinner fa-spin me-1"></i>
//                               Saving...
//                             </>
//                           ) : (
//                             <>
//                               <i className="fas fa-save me-1"></i>
//                               Save Order
//                             </>
//                           )}
//                         </button>

//                         <button
//                           type="button"
//                           className="btn btn-primary"
//                           onClick={generatePDF}
//                           disabled={items.length === 0}
//                         >
//                           <i className="fas fa-download me-1"></i>
//                           Download PDF
//                         </button>

//                         <button
//                           type="button"
//                           className="btn btn-warning"
//                           onClick={handleSendInvoice}
//                           disabled={isSending || items.length === 0 || !orderData.email}
//                         >
//                           {isSending ? (
//                             <>
//                               <i className="fas fa-spinner fa-spin me-1"></i>
//                               Sending...
//                             </>
//                           ) : (
//                             <>
//                               <i className="fas fa-envelope me-1"></i>
//                               Send Invoice
//                             </>
//                           )}
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Modals */}
//       <Modal
//         isOpen={modal.show}
//         onClose={() => setModal({ ...modal, show: false })}
//         title={modal.title}
//       >
//         {modal.message}
//       </Modal>

//       {/* Combo Modal */}
//       {showComboModal && currentComboItem && (
//         <ComboItemModal
//           item={currentComboItem}
//           onCancel={handleComboCancel}
//           onSubmit={handleComboSubmit}
//         />
//       )}

//       <CreateCustomerModal
//         isOpen={showCreateCustomerModal}
//         onClose={() => setShowCreateCustomerModal(false)}
//         onSuccess={handleCustomerCreated}
//       />

//     </div>
//   );
// };

// // Combo Item Modal Component
// const ComboItemModal = ({ item, onCancel, onSubmit }) => {
//   const [selections, setSelections] = useState(() => {
//     const initialSelections = {};
//     if (item?.combo_structure?.[0]?.choice_groups) {
//       item.combo_structure[0].choice_groups.forEach((group) => {
//         initialSelections[group.title] = group.default;
//       });
//     }
//     return initialSelections;
//   });

//   const handleSelectionChange = (groupTitle, option) => {
//     setSelections(prev => ({
//       ...prev,
//       [groupTitle]: option,
//     }));
//   };

//   const handleSubmit = () => {
//     if (!item.combo_structure?.[0]) return;

//     const fixedItems = item.combo_structure[0].fixed_items;
//     const chosenItems = Object.values(selections);

//     let description = `${item?.item_name} - `;
//     fixedItems.forEach((item, index) => {
//       description += `${index + 1}. ${item} `;
//     });
//     chosenItems.forEach((item, index) => {
//       description += `${fixedItems.length + index + 1}. ${item} `;
//     });

//     onSubmit(description);
//   };

//   return (
//     <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
//       <div className="modal-dialog modal-dialog-centered modal-lg">
//         <div className="modal-content">
//           <div className="modal-header">
//             <h5 className="modal-title">{item?.item_name}</h5>
//             <button type="button" className="btn-close" onClick={onCancel}></button>
//           </div>
//           <div className="modal-body">
//             <div className="mb-3">
//               <p className="text-danger fs-5 fw-bold">
//                 Price: ${item?.price}
//               </p>
//             </div>

//             {item?.combo_structure?.[0]?.fixed_items && (
//               <div className="mb-4">
//                 <h6 className="fw-bold">Fixed Items:</h6>
//                 <ul className="list-group">
//                   {item.combo_structure[0].fixed_items.map((item, index) => (
//                     <li key={index} className="list-group-item">
//                       {index + 1}. {item}
//                     </li>
//                   ))}
//                 </ul>
//               </div>
//             )}

//             {item?.combo_structure?.[0]?.choice_groups && (
//               <div className="mb-4">
//                 <h6 className="fw-bold mb-3">Customize:</h6>
//                 <div className="row">
//                   {item.combo_structure[0].choice_groups.map((group, index) => (
//                     <div key={index} className="col-md-6 mb-3">
//                       <h6 className="fw-semibold mb-2">{group.title}</h6>
//                       <div className="form-group">
//                         {group.options.map((option, optIndex) => (
//                           <div key={optIndex} className="form-check">
//                             <input
//                               className="form-check-input"
//                               type="radio"
//                               name={group.title}
//                               id={`${group.title}-${optIndex}`}
//                               value={option}
//                               checked={selections[group.title] === option}
//                               onChange={() => handleSelectionChange(group.title, option)}
//                             />
//                             <label
//                               className="form-check-label"
//                               htmlFor={`${group.title}-${optIndex}`}
//                             >
//                               {option}
//                             </label>
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             )}
//           </div>
//           <div className="modal-footer">
//             <button type="button" className="btn btn-secondary" onClick={onCancel}>
//               Cancel
//             </button>
//             <button type="button" className="btn btn-success" onClick={handleSubmit}>
//               Add to Order
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CreateQwikBistroOrderPage;
